var _style, _defs, _g, _defs2, _g2, _defs3, _g3, _g4, _defs4, _g5, _defs5, _g6, _g7, _g8, _g9, _defs6, _g10, _defs7, _g11, _g12, _g13, _defs8, _g14, _g15, _g16, _g17, _defs9, _g18, _g19, _g20, _g21, _g22, _defs10, _g23, _g24, _defs11, _g25, _g26, _g27, _g28, _defs12, _g29, _defs13, _g30, _g31, _g32, _g33, _defs14, _g34, _g35, _g36, _defs15, _g37, _defs16, _g38, _defs17, _g39, _g40, _defs18, _g41, _defs19, _g42, _g43, _g44, _g45, _defs20, _g46, _defs21, _g47, _g48, _g49, _g50, _defs22, _g51, _g52, _defs23, _g53, _g54, _defs24, _g55, _g56, _defs25, _g57, _defs26, _g58, _defs27, _g59, _defs28, _g60, _g61, _g62, _g63, _defs29, _g64, _g65, _defs30, _g66, _g67, _g68, _g69, _defs31, _g70, _defs32, _g71, _g72, _g73, _defs33, _g74, _defs34, _g75, _defs35, _g76, _defs36, _g77, _defs37, _g78, _g79, _g80, _g81, _g82, _defs38, _g83, _g84, _g85, _g86, _defs39, _g87, _g88, _defs40, _g89, _g90, _defs41, _g91, _g92, _g93, _defs42, _g94, _g95, _g96, _g97, _defs43, _g98, _g99, _g100, _defs44, _g101, _g102, _g103, _g104, _g105, _defs45, _g106, _g107, _g108, _defs46, _g109, _g110, _defs47, _g111, _defs48, _g112, _g113, _g114, _defs49, _g115, _g116, _g117, _g118, _defs50, _g119, _g120, _g121, _defs51, _g122, _defs52, _g123, _g124, _g125, _defs53, _g126, _defs54, _g127, _g128, _defs55, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _defs56, _g136, _defs57, _g137, _g138, _g139, _defs58, _g140, _defs59, _g141, _defs60, _g142, _g143, _defs61, _g144, _defs62, _g145, _g146, _g147, _g148, _defs63, _g149;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFixedTxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237.02 137",
    style: {
      enableBackground: "new 0 0 237.02 137"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{clip-path:url(#SVGID_2_);enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_4_);enable-background:new    ;}\r\n\t.st3{clip-path:url(#SVGID_6_);enable-background:new    ;}\r\n\t.st4{clip-path:url(#SVGID_8_);enable-background:new    ;}\r\n\t.st5{clip-path:url(#SVGID_10_);enable-background:new    ;}\r\n\t.st6{clip-path:url(#SVGID_12_);enable-background:new    ;}\r\n\t.st7{clip-path:url(#SVGID_14_);enable-background:new    ;}\r\n\t.st8{clip-path:url(#SVGID_16_);enable-background:new    ;}\r\n\t.st9{clip-path:url(#SVGID_18_);enable-background:new    ;}\r\n\t.st10{clip-path:url(#SVGID_20_);enable-background:new    ;}\r\n\t.st11{clip-path:url(#SVGID_22_);enable-background:new    ;}\r\n\t.st12{clip-path:url(#SVGID_24_);enable-background:new    ;}\r\n\t.st13{clip-path:url(#SVGID_26_);enable-background:new    ;}\r\n\t.st14{clip-path:url(#SVGID_28_);enable-background:new    ;}\r\n\t.st15{clip-path:url(#SVGID_30_);enable-background:new    ;}\r\n\t.st16{clip-path:url(#SVGID_32_);enable-background:new    ;}\r\n\t.st17{clip-path:url(#SVGID_34_);enable-background:new    ;}\r\n\t.st18{clip-path:url(#SVGID_36_);enable-background:new    ;}\r\n\t.st19{clip-path:url(#SVGID_38_);enable-background:new    ;}\r\n\t.st20{clip-path:url(#SVGID_40_);enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_42_);enable-background:new    ;}\r\n\t.st22{clip-path:url(#SVGID_44_);enable-background:new    ;}\r\n\t.st23{clip-path:url(#SVGID_46_);enable-background:new    ;}\r\n\t.st24{clip-path:url(#SVGID_48_);enable-background:new    ;}\r\n\t.st25{clip-path:url(#SVGID_50_);enable-background:new    ;}\r\n\t.st26{clip-path:url(#SVGID_52_);enable-background:new    ;}\r\n\t.st27{clip-path:url(#SVGID_54_);enable-background:new    ;}\r\n\t.st28{clip-path:url(#SVGID_56_);enable-background:new    ;}\r\n\t.st29{clip-path:url(#SVGID_58_);enable-background:new    ;}\r\n\t.st30{clip-path:url(#SVGID_60_);enable-background:new    ;}\r\n\t.st31{clip-path:url(#SVGID_62_);enable-background:new    ;}\r\n\t.st32{clip-path:url(#SVGID_64_);enable-background:new    ;}\r\n\t.st33{clip-path:url(#SVGID_66_);enable-background:new    ;}\r\n\t.st34{clip-path:url(#SVGID_68_);enable-background:new    ;}\r\n\t.st35{clip-path:url(#SVGID_70_);enable-background:new    ;}\r\n\t.st36{clip-path:url(#SVGID_72_);enable-background:new    ;}\r\n\t.st37{clip-path:url(#SVGID_74_);enable-background:new    ;}\r\n\t.st38{clip-path:url(#SVGID_76_);enable-background:new    ;}\r\n\t.st39{clip-path:url(#SVGID_78_);enable-background:new    ;}\r\n\t.st40{clip-path:url(#SVGID_80_);enable-background:new    ;}\r\n\t.st41{clip-path:url(#SVGID_82_);enable-background:new    ;}\r\n\t.st42{clip-path:url(#SVGID_84_);enable-background:new    ;}\r\n\t.st43{clip-path:url(#SVGID_86_);enable-background:new    ;}\r\n\t.st44{clip-path:url(#SVGID_88_);enable-background:new    ;}\r\n\t.st45{clip-path:url(#SVGID_90_);enable-background:new    ;}\r\n\t.st46{clip-path:url(#SVGID_92_);enable-background:new    ;}\r\n\t.st47{clip-path:url(#SVGID_94_);enable-background:new    ;}\r\n\t.st48{clip-path:url(#SVGID_96_);enable-background:new    ;}\r\n\t.st49{clip-path:url(#SVGID_98_);enable-background:new    ;}\r\n\t.st50{clip-path:url(#SVGID_100_);enable-background:new    ;}\r\n\t.st51{clip-path:url(#SVGID_102_);enable-background:new    ;}\r\n\t.st52{clip-path:url(#SVGID_104_);enable-background:new    ;}\r\n\t.st53{clip-path:url(#SVGID_106_);enable-background:new    ;}\r\n\t.st54{clip-path:url(#SVGID_108_);enable-background:new    ;}\r\n\t.st55{clip-path:url(#SVGID_110_);enable-background:new    ;}\r\n\t.st56{clip-path:url(#SVGID_112_);enable-background:new    ;}\r\n\t.st57{clip-path:url(#SVGID_114_);enable-background:new    ;}\r\n\t.st58{clip-path:url(#SVGID_116_);enable-background:new    ;}\r\n\t.st59{clip-path:url(#SVGID_118_);enable-background:new    ;}\r\n\t.st60{clip-path:url(#SVGID_120_);enable-background:new    ;}\r\n\t.st61{clip-path:url(#SVGID_122_);enable-background:new    ;}\r\n\t.st62{clip-path:url(#SVGID_124_);enable-background:new    ;}\r\n\t.st63{clip-path:url(#SVGID_126_);enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M89.62,12.35l0.01-4.08c0,0.27,0.03,0.55,0.09,0.83l-0.01,4.08 C89.65,12.89,89.62,12.61,89.62,12.35z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.72,9.1l-0.01,4.08c-0.06-0.28-0.09-0.56-0.09-0.83l0.01-4.08C89.63,8.54,89.66,8.82,89.72,9.1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    className: "st0",
    d: "M104.09,13.91l0.01-4.08c0-0.34,0.27-0.67,0.83-1c1.37-0.8,2.59-0.62,4.07,0.24L109,13.15 c-1.48-0.86-2.7-1.03-4.07-0.24C104.37,13.24,104.09,13.57,104.09,13.91z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.01,9.07L109,13.15c-0.32-0.18-0.63-0.34-0.93-0.46l0.01-4.08C108.39,8.73,108.69,8.89,109.01,9.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09,8.61l-0.01,4.08c-0.15-0.06-0.29-0.11-0.43-0.15l0.01-4.08C107.79,8.51,107.94,8.56,108.09,8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65,8.47l-0.01,4.08c-0.1-0.03-0.19-0.05-0.28-0.07l0.01-4.08C107.46,8.42,107.56,8.44,107.65,8.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.37,8.4l-0.01,4.08c-0.07-0.02-0.15-0.03-0.22-0.04l0.01-4.08C107.22,8.37,107.29,8.38,107.37,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,8.36l-0.01,4.08c-0.06-0.01-0.13-0.02-0.19-0.02l0.01-4.08C107.01,8.34,107.08,8.35,107.14,8.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.95,8.33l-0.01,4.08c-0.06-0.01-0.12-0.01-0.18-0.01l0.01-4.08C106.83,8.33,106.89,8.33,106.95,8.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,8.33l-0.01,4.08c-0.06,0-0.12,0-0.18,0l0.01-4.08C106.65,8.32,106.71,8.32,106.77,8.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.58,8.33l-0.01,4.08c-0.07,0-0.13,0.01-0.2,0.01l0.01-4.08C106.45,8.33,106.52,8.33,106.58,8.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39,8.34l-0.01,4.08c-0.08,0.01-0.16,0.02-0.24,0.03l0.01-4.08C106.23,8.36,106.31,8.35,106.39,8.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,8.37l-0.01,4.08c-0.14,0.03-0.28,0.06-0.42,0.11l0.01-4.08C105.87,8.43,106.01,8.4,106.15,8.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,8.48l-0.01,4.08c-0.26,0.08-0.52,0.2-0.79,0.36c-0.02,0.01-0.04,0.02-0.05,0.03l0.01-4.08 c0.02-0.01,0.04-0.02,0.05-0.03C105.21,8.68,105.47,8.56,105.73,8.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,8.87l-0.01,4.08c-0.18,0.11-0.32,0.21-0.44,0.32l0.01-4.08C104.57,9.08,104.71,8.97,104.89,8.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,9.18l-0.01,4.08c-0.06,0.06-0.11,0.11-0.16,0.17l0.01-4.08C104.34,9.3,104.39,9.24,104.45,9.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.29,9.35l-0.01,4.08c-0.03,0.04-0.06,0.09-0.09,0.13l0.01-4.08C104.23,9.44,104.26,9.4,104.29,9.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,9.48l-0.01,4.08c-0.02,0.04-0.04,0.08-0.05,0.12l0.01-4.08C104.16,9.56,104.18,9.52,104.2,9.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,9.6l-0.01,4.08c-0.01,0.04-0.02,0.07-0.03,0.11l0.01-4.08C104.13,9.67,104.14,9.64,104.15,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12,9.71l-0.01,4.08c-0.01,0.04-0.01,0.07-0.01,0.11l0.01-4.08C104.11,9.78,104.11,9.75,104.12,9.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.11,9.82l-0.01,4.08c0,0.01,0,0.01,0,0.02l0.01-4.08C104.11,9.83,104.11,9.82,104.11,9.82"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    className: "st0",
    d: "M94.12,14l-0.01,4.08c-2.5-1.44-3.99-3.07-4.41-4.9l0.01-4.08 C90.14,10.93,91.62,12.55,94.12,14z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.12,14l-0.01,4.08c-2.5-1.44-3.99-3.07-4.41-4.9l0.01-4.08C90.14,10.93,91.62,12.55,94.12,14"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "125.06,18.33 125.05,22.41 109,13.15 109.01,9.07  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    className: "st0",
    d: "M126.36,19.68l-0.01,4.08c0-0.43-0.46-0.87-1.3-1.35l0.01-4.08 C125.89,18.82,126.36,19.25,126.36,19.68z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.36,19.68l-0.01,4.08c0-0.43-0.46-0.87-1.3-1.35l0.01-4.08C125.89,18.82,126.36,19.25,126.36,19.68"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    className: "st0",
    d: "M140.6,21.29l-0.01,4.08c0,1.41-0.84,2.58-2.47,3.53l0.01-4.08 C139.76,23.87,140.6,22.7,140.6,21.29z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.6,21.29l-0.01,4.08c0,0.03,0,0.06,0,0.09l0.01-4.08C140.6,21.35,140.6,21.32,140.6,21.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,21.38l-0.01,4.08c-0.01,0.19-0.03,0.38-0.06,0.56l0.01-4.08C140.57,21.76,140.6,21.57,140.6,21.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.54,21.94l-0.01,4.08c-0.03,0.17-0.08,0.34-0.14,0.5l0.01-4.08C140.46,22.28,140.5,22.11,140.54,21.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.39,22.44l-0.01,4.08c-0.06,0.16-0.13,0.32-0.22,0.47l0.01-4.08C140.26,22.76,140.33,22.61,140.39,22.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,22.92l-0.01,4.08c-0.09,0.16-0.2,0.32-0.32,0.48l0.01-4.08C139.97,23.24,140.08,23.08,140.17,22.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.85,23.4l-0.01,4.08c-0.15,0.19-0.31,0.37-0.5,0.54l0.01-4.08C139.54,23.76,139.7,23.58,139.85,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,23.94l-0.01,4.08c-0.31,0.29-0.67,0.56-1.09,0.81l0.01-4.08C138.68,24.49,139.04,24.22,139.35,23.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.25,24.75l-0.01,4.08c-0.04,0.03-0.08,0.05-0.13,0.07l0.01-4.08C138.17,24.8,138.21,24.77,138.25,24.75"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.5,26.92 116.49,30.99 94.11,18.07 94.12,14  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "138.13,24.82 138.12,28.9 132.59,32.11 132.6,28.04  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.72,9.1c-0.37-1.8,0.44-3.27,2.42-4.42l5.53-3.21c1.98-1.15,4.52-1.62,7.63-1.42c3.16,0.24,6.01,1.06,8.52,2.51 l22.38,12.92c2.5,1.44,3.94,3.1,4.3,4.9c0.42,1.83-0.39,3.3-2.37,4.45l-5.53,3.21c-1.98,1.15-4.52,1.62-7.68,1.39 c-3.11-0.21-5.91-1.06-8.41-2.51L94.12,14C91.62,12.55,90.14,10.93,89.72,9.1z M109.01,9.07c-1.48-0.86-2.7-1.03-4.07-0.24 c-1.27,0.74-1.06,1.5,0.42,2.36l16.25,9.38c1.48,0.86,2.6,0.86,3.87,0.12c1.37-0.8,1.06-1.5-0.42-2.36L109.01,9.07"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    className: "st0",
    d: "M132.6,28.04l-0.01,4.08c-1.98,1.15-4.52,1.62-7.68,1.39c-3.11-0.21-5.91-1.06-8.41-2.51 l0.01-4.08c2.5,1.44,5.31,2.3,8.41,2.51C128.07,29.66,130.62,29.19,132.6,28.04z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.6,28.04l-0.01,4.08c-0.59,0.34-1.23,0.62-1.92,0.85l0.01-4.08C131.37,28.66,132.01,28.38,132.6,28.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,28.88l-0.01,4.08c-0.48,0.15-0.98,0.28-1.5,0.37l0.01-4.08C129.7,29.16,130.2,29.03,130.68,28.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.18,29.25l-0.01,4.08c-0.35,0.06-0.71,0.11-1.09,0.15l0.01-4.08C128.47,29.37,128.83,29.32,129.18,29.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,29.4l-0.01,4.08c-0.34,0.03-0.68,0.06-1.04,0.07l0.01-4.08C127.41,29.46,127.76,29.44,128.09,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06,29.47l-0.01,4.08c-0.35,0.01-0.72,0.01-1.09,0l0.01-4.08C126.34,29.48,126.7,29.48,127.06,29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.97,29.48l-0.01,4.08c-0.34-0.01-0.69-0.03-1.05-0.05c-0.11-0.01-0.23-0.02-0.34-0.03l0.01-4.08 c0.11,0.01,0.23,0.02,0.34,0.03C125.28,29.45,125.63,29.47,125.97,29.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,29.4l-0.01,4.08c-0.41-0.03-0.82-0.08-1.22-0.14l0.01-4.08C123.76,29.32,124.16,29.36,124.57,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36,29.26l-0.01,4.08c-0.42-0.06-0.84-0.13-1.25-0.22l0.01-4.08C122.52,29.13,122.93,29.2,123.36,29.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,29.04l-0.01,4.08c-0.47-0.1-0.93-0.21-1.38-0.34l0.01-4.08C121.18,28.83,121.64,28.95,122.11,29.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,28.71l-0.01,4.08c-0.59-0.17-1.17-0.36-1.73-0.59l0.01-4.08C119.56,28.34,120.14,28.54,120.73,28.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,28.12l-0.01,4.08c-0.86-0.34-1.69-0.74-2.5-1.2l0.01-4.08C117.3,27.38,118.14,27.78,119,28.12"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    className: "st0",
    d: "M75.58,17.28l0.01-4.08c0,0.63,0.59,1.26,1.73,1.91l-0.01,4.08 C76.17,18.54,75.58,17.91,75.58,17.28z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.32,15.12l-0.01,4.08c-1.14-0.66-1.73-1.29-1.73-1.91l0.01-4.08C75.59,13.83,76.18,14.46,77.32,15.12"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "88.25,21.43 88.24,25.51 77.31,19.2 77.32,15.12  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "84.39,22.14 84.38,26.21 77.02,30.49 77.03,26.41  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    className: "st0",
    d: "M60.47,29.01l0.01-4.08c0,0.68,0.55,1.36,1.64,1.98l-0.01,4.08 C61.02,30.37,60.47,29.68,60.47,29.01z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.12,26.92l-0.01,4.08c-1.08-0.63-1.64-1.31-1.64-1.98l0.01-4.08C60.48,25.61,61.03,26.29,62.12,26.92"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "99.55,27.95 99.54,32.03 98.06,31.17 98.07,27.1  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "86.53,30.43 86.52,34.5 79.62,30.52 79.63,26.44  "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "98.07,27.1 98.06,31.17 91.81,34.8 91.83,30.72  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    className: "st0",
    d: "M91.83,30.72l-0.01,4.08c-1.67,0.97-3.3,0.86-5.3-0.29l0.01-4.08 C88.52,31.58,90.15,31.7,91.83,30.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.83,30.72l-0.01,4.08c-0.34,0.2-0.67,0.35-1.01,0.46l0.01-4.08C91.15,31.07,91.49,30.92,91.83,30.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.82,31.18l-0.01,4.08c-0.18,0.06-0.36,0.1-0.54,0.14l0.01-4.08C90.46,31.28,90.64,31.24,90.82,31.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.28,31.31l-0.01,4.08c-0.11,0.02-0.21,0.03-0.32,0.05l0.01-4.08C90.06,31.35,90.17,31.33,90.28,31.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.96,31.36l-0.01,4.08c-0.09,0.01-0.18,0.01-0.27,0.02l0.01-4.08C89.78,31.37,89.87,31.37,89.96,31.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.69,31.38l-0.01,4.08c-0.08,0-0.16,0-0.25,0l0.01-4.08C89.53,31.38,89.61,31.38,89.69,31.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.44,31.38l-0.01,4.08c-0.08,0-0.16-0.01-0.25-0.01l0.01-4.08C89.28,31.37,89.36,31.38,89.44,31.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,31.37l-0.01,4.08c-0.09-0.01-0.17-0.02-0.26-0.03l0.01-4.08C89.02,31.35,89.11,31.36,89.2,31.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.93,31.34l-0.01,4.08c-0.1-0.01-0.2-0.03-0.3-0.05l0.01-4.08C88.73,31.3,88.83,31.32,88.93,31.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,31.28l-0.01,4.08c-0.12-0.03-0.25-0.06-0.37-0.09l0.01-4.08C88.39,31.23,88.51,31.26,88.63,31.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,31.19l-0.01,4.08c-0.19-0.05-0.38-0.12-0.57-0.19L87.69,31C87.88,31.07,88.07,31.14,88.26,31.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,31l-0.01,4.08c-0.37-0.15-0.76-0.34-1.16-0.57l0.01-4.08C86.93,30.66,87.32,30.85,87.69,31"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "114.62,36.65 114.6,40.73 109.34,37.69 109.36,33.61  "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "125.6,34.06 125.59,38.13 120.97,40.82 120.98,36.74  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "97.82,36.95 97.81,41.02 90.91,37.04 90.92,32.97  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "109.36,33.61 109.34,37.69 103.1,41.32 103.11,37.24  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    className: "st0",
    d: "M120.98,36.74l-0.01,4.08c-2.18,1.27-4.17,1.18-6.36-0.09l0.01-4.08 C116.81,37.92,118.8,38.01,120.98,36.74z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.98,36.74l-0.01,4.08c-0.47,0.28-0.94,0.49-1.4,0.64l0.01-4.08C120.04,37.23,120.51,37.02,120.98,36.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,37.38l-0.01,4.08c-0.25,0.08-0.49,0.14-0.74,0.19l0.01-4.08C119.09,37.52,119.34,37.46,119.58,37.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,37.56l-0.01,4.08c-0.14,0.03-0.28,0.05-0.42,0.06l0.01-4.08C118.56,37.61,118.7,37.59,118.84,37.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,37.62l-0.01,4.08c-0.11,0.01-0.22,0.02-0.33,0.02l0.01-4.08C118.2,37.64,118.31,37.63,118.42,37.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09,37.64l-0.01,4.08c-0.1,0-0.2,0-0.3,0l0.01-4.08C117.89,37.65,117.99,37.65,118.09,37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78,37.65l-0.01,4.08c-0.1,0-0.2-0.01-0.3-0.02l0.01-4.08C117.59,37.64,117.68,37.64,117.78,37.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.49,37.63l-0.01,4.08c-0.1-0.01-0.21-0.02-0.31-0.03l0.01-4.08C117.28,37.61,117.38,37.62,117.49,37.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,37.6l-0.01,4.08c-0.12-0.02-0.23-0.04-0.35-0.06l0.01-4.08C116.94,37.56,117.06,37.58,117.18,37.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83,37.53l-0.01,4.08c-0.14-0.03-0.29-0.07-0.43-0.11l0.01-4.08C116.54,37.47,116.68,37.5,116.83,37.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,37.43l-0.01,4.08c-0.21-0.06-0.41-0.13-0.62-0.21l0.01-4.08C115.98,37.3,116.19,37.37,116.39,37.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.77,37.21l-0.01,4.08c-0.38-0.15-0.76-0.34-1.15-0.56l0.01-4.08C115.01,36.88,115.39,37.06,115.77,37.21"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.77,8.75l43.83,25.31l-4.62,2.68c-2.18,1.27-4.17,1.18-6.36-0.09l-5.26-3.04l-6.24,3.63c-1.67,0.97-3.3,0.86-5.3-0.29 l-6.9-3.98l8.63-5.01l-1.48-0.86l-6.24,3.63c-1.67,0.97-3.3,0.86-5.3-0.29l-6.9-3.98l8.63-5.01l-10.93-6.31 c-2.2-1.27-2.36-2.42-0.17-3.69L81.77,8.75z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    className: "st0",
    d: "M103.11,37.24l-0.01,4.08c-1.67,0.97-3.3,0.86-5.3-0.29l0.01-4.08 C99.81,38.1,101.44,38.21,103.11,37.24z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.11,37.24l-0.01,4.08c-0.34,0.2-0.67,0.35-1.01,0.46l0.01-4.08C102.44,37.59,102.78,37.44,103.11,37.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11,37.7l-0.01,4.08c-0.18,0.06-0.36,0.1-0.54,0.14l0.01-4.08C101.75,37.8,101.93,37.75,102.11,37.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57,37.83l-0.01,4.08c-0.11,0.02-0.21,0.03-0.32,0.05l0.01-4.08C101.35,37.87,101.46,37.85,101.57,37.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,37.88l-0.01,4.08c-0.09,0.01-0.18,0.01-0.27,0.02l0.01-4.08C101.07,37.89,101.16,37.89,101.24,37.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.98,37.89l-0.01,4.08c-0.08,0-0.16,0-0.25,0l0.01-4.08C100.81,37.9,100.9,37.9,100.98,37.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.73,37.9l-0.01,4.08c-0.08,0-0.16-0.01-0.25-0.01l0.01-4.08C100.57,37.89,100.65,37.89,100.73,37.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,37.88l-0.01,4.08c-0.09-0.01-0.17-0.02-0.26-0.03l0.01-4.08C100.31,37.87,100.4,37.88,100.48,37.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.22,37.85l-0.01,4.08c-0.1-0.01-0.2-0.03-0.3-0.05l0.01-4.08C100.02,37.82,100.12,37.84,100.22,37.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.92,37.8l-0.01,4.08c-0.12-0.03-0.25-0.06-0.37-0.09l0.01-4.08C99.67,37.74,99.8,37.77,99.92,37.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,37.71l-0.01,4.08c-0.19-0.05-0.38-0.12-0.57-0.19l0.01-4.08C99.17,37.59,99.36,37.65,99.55,37.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.98,37.51l-0.01,4.08c-0.37-0.15-0.76-0.34-1.16-0.57l0.01-4.08C98.22,37.18,98.6,37.37,98.98,37.51"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "94.15,45.41 94.14,49.49 62.11,30.99 62.12,26.92  "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "105.44,42.81 105.42,46.89 100.76,49.6 100.77,45.53  "
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.39,22.14l-7.36,4.28l28.41,16.4l-4.67,2.71c-2.03,1.18-4.52,1.09-6.62-0.12L62.12,26.92 c-2.09-1.21-2.2-2.62-0.17-3.8l12.03-6.99L84.39,22.14z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    className: "st0",
    d: "M100.77,45.53l-0.01,4.08c-2.03,1.18-4.52,1.09-6.62-0.12l0.01-4.08 C96.24,46.62,98.74,46.71,100.77,45.53z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.77,45.53l-0.01,4.08c-0.39,0.22-0.79,0.4-1.2,0.54l0.01-4.08C99.98,45.93,100.38,45.75,100.77,45.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,46.06l-0.01,4.08c-0.26,0.09-0.53,0.15-0.8,0.2l0.01-4.08C99.04,46.22,99.3,46.15,99.57,46.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.76,46.26l-0.01,4.08c-0.16,0.03-0.33,0.05-0.5,0.07l0.01-4.08C98.43,46.32,98.6,46.29,98.76,46.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27,46.33l-0.01,4.08c-0.14,0.01-0.28,0.02-0.42,0.03l0.01-4.08C97.99,46.36,98.13,46.35,98.27,46.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,46.36l-0.01,4.08c-0.13,0-0.26,0-0.38,0l0.01-4.08C97.59,46.37,97.72,46.37,97.85,46.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.47,46.36l-0.01,4.08c-0.13,0-0.25-0.01-0.38-0.02l0.01-4.08C97.22,46.35,97.34,46.36,97.47,46.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,46.34l-0.01,4.08c-0.13-0.01-0.26-0.03-0.39-0.04l0.01-4.08C96.83,46.32,96.96,46.33,97.09,46.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,46.3l-0.01,4.08c-0.14-0.02-0.28-0.04-0.43-0.07l0.01-4.08C96.42,46.25,96.56,46.28,96.7,46.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.27,46.23l-0.01,4.08c-0.16-0.03-0.33-0.07-0.49-0.12l0.01-4.08C95.95,46.15,96.11,46.19,96.27,46.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.78,46.11l-0.01,4.08c-0.22-0.06-0.44-0.14-0.66-0.22l0.01-4.08C95.35,45.97,95.56,46.04,95.78,46.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,45.88l-0.01,4.08c-0.33-0.13-0.66-0.29-0.98-0.47l0.01-4.08C94.47,45.59,94.8,45.75,95.13,45.88"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    className: "st0",
    d: "M142.02,33.85l0.01-4.08c0,0.57,0.54,1.14,1.58,1.74l-0.01,4.08 C142.56,34.99,142.02,34.42,142.02,33.85z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.61,31.51l-0.01,4.08c-1.04-0.6-1.58-1.17-1.58-1.74l0.01-4.08C142.03,30.34,142.57,30.91,143.61,31.51"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "178.83,37.68 178.82,41.76 174.45,44.29 174.46,40.22  "
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "178.45,51.63 178.44,55.7 143.6,35.59 143.61,31.51  "
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "189.28,48.77 189.26,52.84 184.19,55.79 184.2,51.72  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    className: "st0",
    d: "M184.2,51.72l-0.01,4.08c-1.98,1.15-3.76,1.06-5.75-0.09l0.01-4.08 C180.44,52.78,182.22,52.87,184.2,51.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.2,51.72l-0.01,4.08c-0.43,0.25-0.85,0.44-1.26,0.58l0.01-4.08C183.35,52.16,183.77,51.97,184.2,51.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.94,52.29l-0.01,4.08c-0.22,0.07-0.44,0.13-0.66,0.17l0.01-4.08C182.49,52.42,182.72,52.36,182.94,52.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.27,52.46l-0.01,4.08c-0.13,0.02-0.25,0.04-0.38,0.05l0.01-4.08C182.02,52.5,182.15,52.48,182.27,52.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,52.51l-0.01,4.08c-0.1,0.01-0.2,0.02-0.3,0.02l0.01-4.08C181.69,52.53,181.79,52.52,181.89,52.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,52.53l-0.01,4.08c-0.09,0-0.18,0-0.27,0l0.01-4.08C181.41,52.54,181.5,52.54,181.6,52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.32,52.53l-0.01,4.08c-0.09,0-0.18-0.01-0.27-0.01l0.01-4.08C181.14,52.53,181.23,52.53,181.32,52.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,52.52l-0.01,4.08c-0.09-0.01-0.19-0.02-0.28-0.03l0.01-4.08C180.87,52.5,180.96,52.51,181.06,52.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.78,52.49l-0.01,4.08c-0.1-0.01-0.21-0.03-0.31-0.05l0.01-4.08C180.57,52.46,180.67,52.47,180.78,52.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.46,52.43l-0.01,4.08c-0.13-0.03-0.26-0.06-0.39-0.1l0.01-4.08C180.2,52.37,180.33,52.41,180.46,52.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,52.34l-0.01,4.08c-0.19-0.05-0.38-0.12-0.57-0.19l0.01-4.08C179.69,52.22,179.88,52.28,180.07,52.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,52.14l-0.01,4.08c-0.35-0.14-0.7-0.31-1.06-0.52l0.01-4.08C178.81,51.83,179.16,52.01,179.5,52.14"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.61,31.51c-1.99-1.15-2.15-2.18-0.17-3.33l5.07-2.95l15.53,8.96l4.36-2.54l10.43,6.02l-4.36,2.54l14.81,8.55 l-5.07,2.95c-1.98,1.15-3.76,1.06-5.75-0.09L143.61,31.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.35,42.81 140.34,46.89 140.2,46.97 140.21,42.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    className: "st0",
    d: "M145.8,43.14l-0.01,4.08c-2.3-1.33-3.88-1.24-5.45-0.32l0.01-4.08 C141.93,41.9,143.51,41.81,145.8,43.14z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.8,43.14l-0.01,4.08c-0.44-0.25-0.85-0.45-1.24-0.61l0.01-4.08C144.95,42.68,145.37,42.88,145.8,43.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,42.53l-0.01,4.08c-0.2-0.08-0.4-0.15-0.6-0.2l0.01-4.08C144.16,42.38,144.36,42.45,144.56,42.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.97,42.32l-0.01,4.08c-0.13-0.04-0.26-0.07-0.39-0.1l0.01-4.08C143.71,42.25,143.83,42.28,143.97,42.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.58,42.23l-0.01,4.08c-0.1-0.02-0.2-0.04-0.3-0.05l0.01-4.08C143.38,42.19,143.48,42.21,143.58,42.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.28,42.17l-0.01,4.08c-0.09-0.01-0.18-0.02-0.26-0.03l0.01-4.08C143.1,42.15,143.19,42.16,143.28,42.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.02,42.14L143,46.22c-0.08-0.01-0.16-0.01-0.24-0.01l0.01-4.08C142.85,42.13,142.93,42.14,143.02,42.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.77,42.13l-0.01,4.08c-0.08,0-0.16,0-0.24,0l0.01-4.08C142.61,42.13,142.69,42.13,142.77,42.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,42.13l-0.01,4.08c-0.09,0-0.17,0.01-0.26,0.02l0.01-4.08C142.36,42.14,142.44,42.14,142.53,42.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,42.15l-0.01,4.08c-0.11,0.01-0.22,0.03-0.32,0.05l0.01-4.08C142.05,42.18,142.16,42.16,142.27,42.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.95,42.2l-0.01,4.08c-0.19,0.03-0.37,0.08-0.55,0.14l0.01-4.08C141.58,42.28,141.76,42.23,141.95,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,42.33l-0.01,4.08c-0.35,0.11-0.7,0.28-1.04,0.48l0.01-4.08C140.7,42.61,141.05,42.45,141.4,42.33"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    className: "st0",
    d: "M139.07,48.31l0.01-4.08c0-0.49,0.43-0.93,1.13-1.34l-0.01,4.08 C139.49,47.38,139.07,47.82,139.07,48.31z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.21,42.9l-0.01,4.08c-0.03,0.02-0.05,0.03-0.08,0.05l0.01-4.08C140.16,42.93,140.18,42.91,140.21,42.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.13,42.94l-0.01,4.08c-0.23,0.14-0.43,0.29-0.6,0.43l0.01-4.08C139.7,43.23,139.9,43.08,140.13,42.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.53,43.38l-0.01,4.08c-0.08,0.07-0.15,0.15-0.21,0.23l0.01-4.08C139.38,43.52,139.45,43.45,139.53,43.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.32,43.6l-0.01,4.08c-0.04,0.06-0.08,0.11-0.12,0.17l0.01-4.08C139.24,43.71,139.28,43.66,139.32,43.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,43.77l-0.01,4.08c-0.03,0.05-0.05,0.1-0.07,0.15l0.01-4.08C139.16,43.87,139.18,43.82,139.21,43.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,43.92L139.12,48c-0.02,0.05-0.03,0.09-0.04,0.14l0.01-4.08C139.1,44.02,139.12,43.97,139.14,43.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1,44.07l-0.01,4.08c-0.01,0.05-0.02,0.1-0.02,0.14l0.01-4.08C139.08,44.16,139.09,44.11,139.1,44.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,44.21l-0.01,4.08c0,0.01,0,0.01,0,0.02l0.01-4.08C139.08,44.22,139.08,44.22,139.08,44.21"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    className: "st0",
    d: "M124.44,46.57l0.01-4.08c0,0.12,0,0.25,0.02,0.38c0.21,1.95,1.6,3.63,4.1,5.07l-0.01,4.08 c-2.5-1.44-3.89-3.13-4.1-5.07C124.45,46.82,124.44,46.69,124.44,46.57z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.57,47.94l-0.01,4.08c-2.5-1.44-3.89-3.13-4.1-5.07c-0.01-0.13-0.02-0.25-0.02-0.38l0.01-4.08 c0,0.12,0,0.25,0.02,0.38C124.69,44.82,126.07,46.5,128.57,47.94"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "158.48,50.45 158.47,54.53 145.79,47.21 145.8,43.14  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    className: "st0",
    d: "M160.22,52.27l-0.01,4.08c0-0.53-0.53-1.12-1.75-1.82l0.01-4.08 C159.69,51.15,160.22,51.74,160.22,52.27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.22,52.27l-0.01,4.08c0-0.53-0.53-1.12-1.75-1.82l0.01-4.08C159.69,51.15,160.22,51.74,160.22,52.27"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    className: "st0",
    d: "M174.72,54.13l-0.01,4.08c0,1.73-1.08,3.19-3.26,4.46l0.01-4.08 C173.64,57.32,174.71,55.86,174.72,54.13z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.72,54.13l-0.01,4.08c0,0.04,0,0.07,0,0.11l0.01-4.08C174.72,54.2,174.72,54.17,174.72,54.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,54.24l-0.01,4.08c-0.01,0.22-0.03,0.44-0.07,0.66l0.01-4.08C174.69,54.68,174.71,54.46,174.72,54.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64,54.9l-0.01,4.08c-0.04,0.2-0.1,0.4-0.17,0.6l0.01-4.08C174.55,55.3,174.6,55.1,174.64,54.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,55.5l-0.01,4.08c-0.07,0.2-0.16,0.39-0.27,0.58l0.01-4.08C174.31,55.88,174.4,55.69,174.47,55.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,56.07l-0.01,4.08c-0.12,0.2-0.25,0.4-0.4,0.6l0.01-4.08C173.95,56.48,174.09,56.28,174.2,56.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.8,56.67l-0.01,4.08c-0.19,0.24-0.4,0.47-0.65,0.7l0.01-4.08C173.4,57.14,173.61,56.91,173.8,56.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,57.37l-0.01,4.08c-0.42,0.39-0.92,0.76-1.51,1.11l0.01-4.08C172.23,58.13,172.73,57.76,173.15,57.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.64,58.48l-0.01,4.08c-0.06,0.04-0.12,0.07-0.19,0.11l0.01-4.08C171.52,58.55,171.58,58.52,171.64,58.48"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "150.24,60.45 150.22,64.53 128.56,52.02 128.57,47.94  "
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "171.46,58.59 171.44,62.67 167.54,64.94 167.55,60.86  "
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.69,53.63c0.21,1.95-0.85,3.57-3.24,4.96l-3.91,2.27c-2.39,1.39-5.23,2.03-8.59,1.92c-3.31-0.09-6.22-0.88-8.72-2.33 l-21.66-12.51c-2.5-1.44-3.89-3.13-4.1-5.07c-0.16-1.92,0.95-3.57,3.33-4.95l3.91-2.27c2.39-1.39,5.19-2.01,8.5-1.92 c3.36,0.12,6.32,0.88,8.82,2.33l21.66,12.51C173.19,50.01,174.53,51.72,174.69,53.63z M158.91,53.69l0.15-0.08 c1.57-0.91,1.72-1.83-0.58-3.16l-12.67-7.32c-2.3-1.33-3.88-1.24-5.45-0.32l-0.15,0.08c-1.47,0.86-1.73,1.83,0.57,3.16 l12.67,7.32C155.75,54.7,157.44,54.55,158.91,53.69"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    className: "st0",
    d: "M167.55,60.86l-0.01,4.08c-2.39,1.39-5.23,2.03-8.59,1.92c-3.31-0.09-6.22-0.88-8.72-2.33 l0.01-4.08c2.5,1.44,5.41,2.24,8.72,2.33C162.32,62.9,165.16,62.25,167.55,60.86z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.55,60.86l-0.01,4.08c-0.83,0.48-1.71,0.87-2.66,1.18l0.01-4.08C165.83,61.74,166.72,61.34,167.55,60.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89,62.04l-0.01,4.08c-0.62,0.2-1.26,0.36-1.92,0.48l0.01-4.08C163.63,62.4,164.28,62.24,164.89,62.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.97,62.52l-0.01,4.08c-0.43,0.08-0.88,0.14-1.33,0.19l0.01-4.08C162.09,62.66,162.54,62.59,162.97,62.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,62.7l-0.01,4.08c-0.4,0.04-0.81,0.07-1.22,0.08l0.01-4.08C160.83,62.77,161.24,62.74,161.64,62.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.42,62.78l-0.01,4.08c-0.46,0.02-0.92,0.02-1.4,0l0.01-4.08C159.49,62.8,159.96,62.8,160.42,62.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.01,62.78L159,66.86c-0.02,0-0.04,0-0.06,0c-0.41-0.01-0.82-0.03-1.22-0.07l0.01-4.08c0.4,0.03,0.81,0.06,1.22,0.07 C158.97,62.78,158.99,62.78,159.01,62.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73,62.71l-0.01,4.08c-0.4-0.03-0.8-0.08-1.2-0.13l0.01-4.08C156.93,62.63,157.33,62.68,157.73,62.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,62.58l-0.01,4.08c-0.41-0.06-0.81-0.13-1.2-0.21l0.01-4.08C155.73,62.45,156.13,62.52,156.54,62.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34,62.37l-0.01,4.08c-0.44-0.09-0.87-0.2-1.3-0.32l0.01-4.08C154.46,62.17,154.89,62.28,155.34,62.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.04,62.05l-0.01,4.08c-0.54-0.16-1.07-0.33-1.59-0.54l0.01-4.08C152.96,61.72,153.49,61.9,154.04,62.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,61.51l-0.01,4.08c-0.77-0.3-1.51-0.66-2.21-1.07l0.01-4.08C150.94,60.86,151.68,61.21,152.45,61.51"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    className: "st0",
    d: "M104.98,54.25l0.01-4.08c0,0.84,0.64,1.7,1.86,2.4l-0.01,4.08 C105.63,55.94,104.98,55.09,104.98,54.25z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.86,52.57l-0.01,4.08c-1.22-0.7-1.87-1.56-1.86-2.4l0.01-4.08C104.99,51.01,105.64,51.87,106.86,52.57"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "143.3,57.97 143.29,62.05 137.65,65.32 137.66,61.25  "
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "142.31,73.04 142.3,77.12 106.85,56.65 106.86,52.57  "
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "154.21,70.8 154.2,74.88 150.09,77.26 150.1,73.19  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    className: "st0",
    d: "M150.1,73.19l-0.01,4.08c-2.28,1.33-5.39,1.24-7.79-0.15l0.01-4.08 C144.71,74.43,147.82,74.52,150.1,73.19z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.1,73.19l-0.01,4.08c-0.41,0.24-0.85,0.43-1.3,0.58l0.01-4.08C149.25,73.62,149.69,73.43,150.1,73.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,73.77l-0.01,4.08c-0.31,0.1-0.64,0.18-0.96,0.24l0.01-4.08C148.16,73.95,148.49,73.87,148.8,73.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,74.01l-0.01,4.08c-0.2,0.04-0.4,0.06-0.61,0.08l0.01-4.08C147.43,74.07,147.63,74.05,147.83,74.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.23,74.09l-0.01,4.08c-0.17,0.02-0.35,0.03-0.52,0.03l0.01-4.08C146.88,74.12,147.06,74.11,147.23,74.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,74.13l-0.01,4.08c-0.16,0.01-0.32,0.01-0.48,0l0.01-4.08C146.39,74.14,146.55,74.14,146.71,74.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,74.13l-0.01,4.08c-0.16,0-0.32-0.01-0.47-0.03l0.01-4.08C145.91,74.12,146.07,74.13,146.22,74.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75,74.11l-0.01,4.08c-0.16-0.01-0.33-0.03-0.49-0.05l0.01-4.08C145.43,74.07,145.59,74.09,145.75,74.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.26,74.05l-0.01,4.08c-0.18-0.02-0.35-0.06-0.52-0.09l0.01-4.08C144.91,74,145.09,74.03,145.26,74.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74,73.96l-0.01,4.08c-0.2-0.04-0.4-0.09-0.6-0.15l0.01-4.08C144.34,73.87,144.54,73.92,144.74,73.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,73.81l-0.01,4.08c-0.26-0.07-0.51-0.16-0.76-0.26l0.01-4.08C143.63,73.65,143.88,73.74,144.14,73.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,73.56l-0.01,4.08c-0.37-0.14-0.72-0.32-1.07-0.51l0.01-4.08C142.66,73.24,143.01,73.41,143.38,73.56"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.66,61.25l16.55,9.55l-4.11,2.39c-2.28,1.33-5.39,1.24-7.79-0.15l-35.45-20.47c-2.3-1.33-2.56-3.18-0.28-4.51 l4.11-2.39l16.65,9.61l5.63-3.27l10.32,5.96L137.66,61.25z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    className: "st0",
    d: "M201.51,62.54l-0.01,4.08c-1.07-0.62-2.19-0.86-4.38,0.41l0.01-4.08 C199.32,61.68,200.44,61.92,201.51,62.54z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.51,62.54l-0.01,4.08c-0.19-0.11-0.39-0.21-0.59-0.29l0.01-4.08C201.13,62.32,201.32,62.42,201.51,62.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.92,62.24l-0.01,4.08c-0.1-0.04-0.2-0.07-0.3-0.1l0.01-4.08C200.73,62.17,200.83,62.21,200.92,62.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,62.14l-0.01,4.08c-0.07-0.02-0.14-0.04-0.21-0.05l0.01-4.08C200.49,62.11,200.56,62.12,200.63,62.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,62.09l-0.01,4.08c-0.06-0.01-0.12-0.02-0.18-0.03l0.01-4.08C200.3,62.07,200.36,62.08,200.42,62.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.24,62.06l-0.01,4.08c-0.05-0.01-0.11-0.01-0.17-0.02l0.01-4.08C200.13,62.05,200.19,62.05,200.24,62.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,62.04l-0.01,4.08c-0.05,0-0.11-0.01-0.17-0.01l0.01-4.08C199.97,62.03,200.02,62.04,200.08,62.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.91,62.03l-0.01,4.08c-0.06,0-0.12,0-0.18,0l0.01-4.08C199.8,62.03,199.86,62.03,199.91,62.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74,62.03l-0.01,4.08c-0.07,0-0.14,0.01-0.21,0.01l0.01-4.08C199.6,62.04,199.67,62.04,199.74,62.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,62.05l-0.01,4.08c-0.09,0.01-0.19,0.02-0.29,0.04l0.01-4.08C199.34,62.07,199.44,62.06,199.53,62.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,62.09l-0.01,4.08c-0.18,0.03-0.37,0.08-0.57,0.15l0.01-4.08C198.87,62.17,199.06,62.12,199.25,62.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,62.24l-0.01,4.08c-0.45,0.15-0.95,0.38-1.53,0.71l0.01-4.08C197.72,62.61,198.22,62.38,198.67,62.24"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "204.17,64.07 204.16,68.14 201.5,66.61 201.51,62.54  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    className: "st0",
    d: "M205.04,65.04l-0.01,4.08c0-0.37-0.36-0.68-0.87-0.97l0.01-4.08 C204.68,64.37,205.05,64.67,205.04,65.04z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.04,65.04l-0.01,4.08c0-0.37-0.36-0.68-0.87-0.97l0.01-4.08C204.68,64.37,205.05,64.67,205.04,65.04"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "197.14,62.95 197.13,67.02 183.47,74.96 183.48,70.88  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    className: "st0",
    d: "M220.2,66.56l-0.01,4.08c0,1.61-1.2,3.22-3.61,4.62l0.01-4.08 C219,69.78,220.2,68.17,220.2,66.56z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.2,66.56l-0.01,4.08c0,0.03,0,0.06,0,0.08l0.01-4.08C220.2,66.62,220.2,66.59,220.2,66.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.2,66.64l-0.01,4.08c-0.01,0.19-0.03,0.37-0.06,0.56l0.01-4.08C220.17,67.02,220.19,66.83,220.2,66.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,67.2l-0.01,4.08c-0.04,0.19-0.09,0.37-0.16,0.56l0.01-4.08C220.04,67.57,220.1,67.39,220.13,67.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.97,67.76l-0.01,4.08c-0.07,0.2-0.17,0.39-0.27,0.58l0.01-4.08C219.81,68.15,219.9,67.95,219.97,67.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,68.34l-0.01,4.08c-0.12,0.22-0.27,0.43-0.44,0.65l0.01-4.08C219.43,68.78,219.58,68.56,219.7,68.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.26,68.99l-0.01,4.08c-0.21,0.27-0.46,0.53-0.74,0.79l0.01-4.08C218.81,69.52,219.05,69.26,219.26,68.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,69.78l-0.01,4.08c-0.48,0.44-1.06,0.87-1.74,1.28l0.01-4.08C217.46,70.66,218.04,70.23,218.52,69.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,71.07l-0.01,4.08c-0.06,0.04-0.13,0.08-0.19,0.11l0.01-4.08C216.65,71.14,216.72,71.1,216.78,71.07"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    className: "st0",
    d: "M181.93,76.52l0.01-4.08c0-0.42,0.43-0.92,1.54-1.56l-0.01,4.08 C182.37,75.6,181.94,76.1,181.93,76.52z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.48,70.88l-0.01,4.08c-0.05,0.03-0.1,0.06-0.15,0.09l0.01-4.08C183.38,70.94,183.43,70.91,183.48,70.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33,70.97l-0.01,4.08c-0.39,0.24-0.69,0.45-0.91,0.65l0.01-4.08C182.64,71.43,182.94,71.21,183.33,70.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.42,71.63l-0.01,4.08c-0.1,0.09-0.18,0.18-0.25,0.26l0.01-4.08C182.24,71.81,182.33,71.72,182.42,71.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.18,71.89l-0.01,4.08c-0.05,0.06-0.09,0.12-0.12,0.17l0.01-4.08C182.09,72.01,182.13,71.95,182.18,71.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.06,72.06l-0.01,4.08c-0.03,0.05-0.05,0.09-0.07,0.14l0.01-4.08C182.01,72.16,182.03,72.11,182.06,72.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.99,72.2l-0.01,4.08c-0.02,0.04-0.03,0.08-0.03,0.12l0.01-4.08C181.97,72.28,181.98,72.24,181.99,72.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.96,72.32l-0.01,4.08c-0.01,0.04-0.01,0.07-0.01,0.11l0.01-4.08C181.95,72.4,181.95,72.36,181.96,72.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.95,72.43l-0.01,4.08c0,0.01,0,0.01,0,0.02l0.01-4.08C181.95,72.44,181.95,72.44,181.95,72.43"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    className: "st0",
    d: "M166.78,75.01l0.01-4.08c0,1.61,1.16,3.21,3.53,4.58l-0.01,4.08 C167.95,78.23,166.78,76.62,166.78,75.01z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.32,75.51l-0.01,4.08c-2.36-1.36-3.53-2.97-3.53-4.58l0.01-4.08C166.79,72.54,167.96,74.15,170.32,75.51"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    className: "st0",
    d: "M152.21,81.53l0.01-4.08c0,0.74,0.63,1.5,1.83,2.19l-0.01,4.08 C152.84,83.03,152.21,82.27,152.21,81.53z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.05,79.64l-0.01,4.08c-1.2-0.69-1.83-1.45-1.83-2.19l0.01-4.08C152.22,78.2,152.85,78.95,154.05,79.64"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "216.59,71.18 216.58,75.26 197.74,86.2 197.76,82.12  "
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "181.87,82.18 181.85,86.26 170.31,79.59 170.32,75.51  "
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.32,75.51c-4.75-2.74-4.67-6.46,0.05-9.2l18.83-10.94c4.82-2.8,11.13-2.8,15.88-0.06l11.54,6.66 c4.75,2.74,4.78,6.4-0.04,9.2l-18.83,10.94c-4.72,2.74-11.14,2.8-15.89,0.06L170.32,75.51z M197.14,62.95l-13.66,7.94 c-2.08,1.21-1.77,1.92-0.7,2.54l2.66,1.53c1.07,0.62,2.3,0.8,4.38-0.41l13.66-7.94c2.18-1.27,1.77-1.92,0.7-2.54l-2.66-1.53 C200.44,61.92,199.32,61.68,197.14,62.95"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    className: "st0",
    d: "M197.76,82.12l-0.01,4.08c-4.72,2.74-11.14,2.8-15.89,0.06l0.01-4.08 C186.62,84.92,193.04,84.87,197.76,82.12z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.76,82.12l-0.01,4.08c-0.92,0.53-1.9,0.97-2.93,1.3l0.01-4.08C195.85,83.09,196.84,82.66,197.76,82.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,83.42l-0.01,4.08c-0.68,0.22-1.37,0.39-2.07,0.52l0.01-4.08C193.46,83.81,194.15,83.64,194.83,83.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,83.94l-0.01,4.08c-0.44,0.08-0.89,0.14-1.34,0.19l0.01-4.08C191.87,84.08,192.31,84.02,192.75,83.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42,84.13l-0.01,4.08c-0.36,0.04-0.73,0.06-1.1,0.07l0.01-4.08C190.69,84.19,191.05,84.16,191.42,84.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.32,84.2l-0.01,4.08c-0.34,0.01-0.67,0.01-1.01,0l0.01-4.08C189.65,84.21,189.99,84.21,190.32,84.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.32,84.2l-0.01,4.08c-0.32-0.01-0.65-0.03-0.97-0.05l0.01-4.08C188.67,84.18,188.99,84.2,189.32,84.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,84.15l-0.01,4.08c-0.33-0.03-0.65-0.06-0.97-0.11l0.01-4.08C187.7,84.09,188.02,84.12,188.35,84.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.37,84.04l-0.01,4.08c-0.34-0.05-0.69-0.11-1.03-0.18l0.01-4.08C186.69,83.93,187.03,83.99,187.37,84.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,83.86l-0.01,4.08c-0.39-0.08-0.77-0.17-1.15-0.28l0.01-4.08C185.58,83.69,185.96,83.78,186.35,83.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,83.58l-0.01,4.08c-0.48-0.14-0.96-0.3-1.42-0.48l0.01-4.08C184.24,83.28,184.71,83.44,185.2,83.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,83.1l-0.01,4.08c-0.66-0.26-1.3-0.57-1.91-0.92l0.01-4.08C182.48,82.53,183.11,82.84,183.77,83.1"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "174.74,91.59 174.73,95.66 154.04,83.72 154.05,79.64  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_59_",
    className: "st0",
    d: "M181.02,94.39l-0.01,4.08c-0.61-0.17-1.52-0.53-2.65-1c-1.23-0.53-2.46-1.12-3.63-1.8 l0.01-4.08c1.17,0.68,2.4,1.27,3.63,1.8C179.49,93.86,180.41,94.21,181.02,94.39z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.02,94.39l-0.01,4.08c-0.38-0.11-0.89-0.29-1.5-0.53l0.01-4.08C180.12,94.1,180.63,94.28,181.02,94.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.52,93.86l-0.01,4.08c-0.35-0.14-0.73-0.29-1.15-0.47c-1.23-0.53-2.46-1.12-3.63-1.8l0.01-4.08 c1.17,0.68,2.4,1.27,3.63,1.8C178.78,93.56,179.17,93.72,179.52,93.86"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "237.02,73.86 237.01,77.94 196.96,101.21 196.97,97.13  "
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "183.74,97.13 183.73,101.21 179.99,99.05 180,94.98  "
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.64,67.87l10.38,5.99l-40.04,23.27c-1.88,1.09-4.06,1.59-6.61,1.59c-2.55,0-4.74-0.5-6.63-1.59L180,94.98l1.01-0.59 c-0.61-0.17-1.52-0.53-2.65-1c-1.23-0.53-2.46-1.12-3.63-1.8l-20.69-11.94c-2.25-1.3-2.51-2.8-0.33-4.07l4.52-2.62l24.67,14.24 c1.07,0.62,2.25,1.18,3.48,1.71c1.07,0.5,1.88,0.79,2.44,0.94L226.64,67.87z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    className: "st0",
    d: "M196.97,97.13l-0.01,4.08c-1.88,1.09-4.06,1.59-6.61,1.59c-2.55,0-4.74-0.5-6.63-1.59 l0.01-4.08c1.89,1.09,4.08,1.59,6.63,1.59C192.91,98.73,195.1,98.23,196.97,97.13z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.97,97.13l-0.01,4.08c-0.68,0.39-1.4,0.71-2.16,0.96l0.01-4.08C195.58,97.85,196.3,97.53,196.97,97.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,98.09l-0.01,4.08c-0.52,0.17-1.05,0.3-1.61,0.4l0.01-4.08C193.77,98.39,194.3,98.26,194.82,98.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,98.49l-0.01,4.08c-0.37,0.07-0.75,0.12-1.14,0.16l0.01-4.08C192.46,98.61,192.84,98.55,193.21,98.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,98.65l-0.01,4.08c-0.35,0.03-0.71,0.06-1.08,0.07l0.01-4.08C191.36,98.7,191.72,98.68,192.07,98.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,98.72l-0.01,4.08c-0.21,0.01-0.42,0.01-0.63,0.01c-0.16,0-0.31,0-0.47-0.01l0.01-4.08c0.15,0,0.31,0.01,0.47,0.01 C190.58,98.73,190.79,98.72,191,98.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.9,98.72l-0.01,4.08c-0.33-0.01-0.66-0.03-0.98-0.05l0.01-4.08C189.24,98.7,189.56,98.71,189.9,98.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,98.67l-0.01,4.08c-0.3-0.02-0.6-0.06-0.89-0.1l0.01-4.08C188.32,98.61,188.62,98.64,188.92,98.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.03,98.57l-0.01,4.08c-0.29-0.04-0.58-0.09-0.86-0.15l0.01-4.08C187.45,98.48,187.74,98.53,188.03,98.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,98.42l-0.01,4.08c-0.31-0.06-0.61-0.14-0.9-0.22l0.01-4.08C186.57,98.28,186.87,98.36,187.17,98.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.27,98.2l-0.01,4.08c-0.37-0.1-0.72-0.22-1.07-0.36l0.01-4.08C185.55,97.98,185.91,98.1,186.27,98.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,97.84l-0.01,4.08c-0.51-0.2-1-0.43-1.46-0.7l0.01-4.08C184.21,97.41,184.7,97.64,185.2,97.84"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_63_",
    className: "st0",
    d: "M47.45,42.25l-0.01,4.08c-1.23-0.71-2.14-0.41-3,0.09l0.01-4.08 C45.3,41.83,46.22,41.54,47.45,42.25z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.45,42.25l-0.01,4.08c-0.16-0.09-0.32-0.17-0.48-0.23l0.01-4.08C47.12,42.08,47.28,42.15,47.45,42.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.97,42.02l-0.01,4.08c-0.09-0.04-0.18-0.07-0.27-0.09l0.01-4.08C46.79,41.95,46.88,41.98,46.97,42.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7,41.92L46.69,46c-0.06-0.02-0.13-0.03-0.19-0.05l0.01-4.08C46.58,41.89,46.64,41.91,46.7,41.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.51,41.88l-0.01,4.08c-0.05-0.01-0.1-0.02-0.15-0.03l0.01-4.08C46.41,41.86,46.46,41.87,46.51,41.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36,41.85l-0.01,4.08c-0.05-0.01-0.09-0.01-0.14-0.02l0.01-4.08C46.27,41.84,46.31,41.84,46.36,41.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.22,41.83l-0.01,4.08c-0.04,0-0.09-0.01-0.13-0.01l0.01-4.08C46.13,41.83,46.18,41.83,46.22,41.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,41.83l-0.01,4.08c-0.05,0-0.09,0-0.13,0l0.01-4.08C46,41.83,46.04,41.83,46.09,41.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.95,41.83l-0.01,4.08c-0.05,0-0.1,0.01-0.15,0.01l0.01-4.08C45.85,41.83,45.9,41.83,45.95,41.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,41.84l-0.01,4.08c-0.07,0.01-0.13,0.02-0.19,0.03l0.01-4.08C45.67,41.85,45.74,41.84,45.8,41.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,41.87l-0.01,4.08c-0.12,0.02-0.23,0.05-0.34,0.09l0.01-4.08C45.38,41.92,45.49,41.89,45.61,41.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.27,41.95l-0.01,4.08c-0.28,0.09-0.56,0.23-0.82,0.38l0.01-4.08C44.71,42.18,44.98,42.04,45.27,41.95"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47.9,42.51 47.89,46.59 47.43,46.32 47.45,42.25  "
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "44.44,42.34 44.43,46.41 43.92,46.71 43.93,42.63  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_65_",
    className: "st0",
    d: "M48.63,43.33l-0.01,4.08c0-0.25-0.21-0.52-0.73-0.82l0.01-4.08 C48.43,42.81,48.64,43.08,48.63,43.33z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.63,43.33l-0.01,4.08c0-0.25-0.21-0.52-0.73-0.82l0.01-4.08C48.43,42.81,48.64,43.08,48.63,43.33"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_67_",
    className: "st0",
    d: "M43.05,47.63l0.01-4.08c0-0.33,0.38-0.63,0.87-0.92l-0.01,4.08 C43.43,46.99,43.05,47.29,43.05,47.63z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.93,42.63l-0.01,4.08c-0.03,0.02-0.07,0.04-0.1,0.06l0.01-4.08C43.87,42.67,43.9,42.65,43.93,42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84,42.69l-0.01,4.08c-0.19,0.12-0.36,0.23-0.49,0.35l0.01-4.08C43.48,42.92,43.65,42.8,43.84,42.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,43.04l-0.01,4.08c-0.05,0.05-0.1,0.1-0.14,0.15l0.01-4.08C43.24,43.14,43.29,43.09,43.34,43.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.21,43.19l-0.01,4.08c-0.03,0.03-0.05,0.07-0.07,0.1l0.01-4.08C43.15,43.26,43.18,43.22,43.21,43.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,43.29l-0.01,4.08c-0.02,0.03-0.03,0.06-0.04,0.09l0.01-4.08C43.1,43.35,43.12,43.32,43.13,43.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,43.38l-0.01,4.08c-0.01,0.03-0.02,0.05-0.02,0.08l0.01-4.08C43.08,43.43,43.08,43.41,43.09,43.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.07,43.46l-0.01,4.08c-0.01,0.03-0.01,0.05-0.01,0.08l0.01-4.08C43.06,43.51,43.07,43.49,43.07,43.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.06,43.54 43.05,47.61 43.05,47.63 43.06,43.55 43.06,43.54  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_69_",
    className: "st0",
    d: "M30.08,46.35l0.01-4.08c0,1.4,1.1,2.88,3.58,4.31l-0.01,4.08 C31.18,49.22,30.08,47.75,30.08,46.35z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.67,46.58l-0.01,4.08c-2.48-1.43-3.59-2.91-3.58-4.31l0.01-4.08C30.09,43.67,31.19,45.15,33.67,46.58"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_71_",
    className: "st0",
    d: "M20.41,49.87l0.01-4.08c0,0.55,0.55,1.1,1.6,1.7l-0.01,4.08 C20.96,50.97,20.41,50.42,20.41,49.87z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.02,47.5l-0.01,4.08c-1.05-0.6-1.6-1.15-1.6-1.7l0.01-4.08C20.42,46.35,20.97,46.89,22.02,47.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_73_",
    className: "st0",
    d: "M61.71,44.56l-0.01,4.08c0,1.39-1.1,2.71-3.03,3.83l0.01-4.08 C60.61,47.27,61.71,45.95,61.71,44.56z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.71,44.56l-0.01,4.08c0,0.02,0,0.05,0,0.07l0.01-4.08C61.71,44.6,61.71,44.58,61.71,44.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.71,44.63L61.7,48.7c0,0.15-0.02,0.3-0.05,0.45l0.01-4.08C61.69,44.93,61.71,44.78,61.71,44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,45.08l-0.01,4.08c-0.03,0.15-0.07,0.3-0.13,0.45l0.01-4.08C61.59,45.38,61.63,45.23,61.66,45.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.53,45.53l-0.01,4.08c-0.06,0.16-0.14,0.32-0.22,0.48l0.01-4.08C61.39,45.85,61.47,45.69,61.53,45.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,46.01l-0.01,4.08c-0.1,0.18-0.22,0.35-0.36,0.53l0.01-4.08C61.08,46.36,61.2,46.19,61.3,46.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.95,46.54l-0.01,4.08c-0.18,0.23-0.38,0.45-0.62,0.66l0.01-4.08C60.56,46.98,60.77,46.76,60.95,46.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,47.2l-0.01,4.08c-0.41,0.38-0.91,0.74-1.48,1.09l0.01-4.08C59.43,47.94,59.92,47.58,60.33,47.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.85,48.29l-0.01,4.08c-0.05,0.03-0.11,0.07-0.17,0.1l0.01-4.08C58.74,48.35,58.8,48.32,58.85,48.29"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.03,49.24 25.02,53.31 22.01,51.57 22.02,47.5  "
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "40.47,50.5 40.45,54.58 33.66,50.66 33.67,46.58  "
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "58.69,48.38 58.67,52.46 54.51,54.88 54.53,50.8  "
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.67,46.58c-4.95-2.86-4.41-5.9-0.55-8.14l4.16-2.42c3.86-2.24,9.1-2.57,14.05,0.29l6.79,3.92 c4.96,2.86,4.42,5.9,0.56,8.14l-4.16,2.42c-3.86,2.24-9.1,2.57-14.06-0.3L33.67,46.58z M44.44,42.34l-0.51,0.29 c-0.86,0.5-1.37,1.03-0.14,1.74l0.46,0.27c1.23,0.71,2.14,0.41,3-0.09l0.51-0.29c0.86-0.5,1.37-1.03,0.14-1.74l-0.46-0.27 C46.22,41.54,45.3,41.83,44.44,42.34"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_75_",
    className: "st0",
    d: "M54.53,50.8l-0.01,4.08c-3.86,2.24-9.1,2.57-14.06-0.3l0.01-4.08 C45.43,53.37,50.67,53.04,54.53,50.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.53,50.8l-0.01,4.08c-0.79,0.46-1.64,0.84-2.53,1.13l0.01-4.08C52.89,51.64,53.73,51.26,54.53,50.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.99,51.93L51.98,56c-0.55,0.18-1.11,0.32-1.69,0.42l0.01-4.08C50.88,52.25,51.44,52.11,51.99,51.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3,52.35l-0.01,4.08c-0.35,0.06-0.71,0.11-1.07,0.15l0.01-4.08C49.6,52.47,49.95,52.42,50.3,52.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.24,52.5l-0.01,4.08c-0.29,0.03-0.58,0.05-0.88,0.06l0.01-4.08C48.66,52.55,48.95,52.53,49.24,52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.36,52.56l-0.01,4.08c-0.27,0.01-0.54,0.01-0.81,0l0.01-4.08C47.82,52.57,48.09,52.57,48.36,52.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.55,52.56l-0.01,4.08c-0.26-0.01-0.53-0.02-0.79-0.04l0.01-4.08C47.02,52.54,47.29,52.56,47.55,52.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.76,52.52l-0.01,4.08c-0.27-0.02-0.54-0.05-0.82-0.09l0.01-4.08C46.21,52.47,46.49,52.5,46.76,52.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.94,52.43l-0.01,4.08c-0.29-0.04-0.59-0.09-0.89-0.15l0.01-4.08C45.35,52.34,45.65,52.39,45.94,52.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.05,52.27l-0.01,4.08c-0.35-0.07-0.7-0.16-1.05-0.26l0.01-4.08C44.36,52.12,44.71,52.2,45.05,52.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.01,52.02l-0.01,4.08c-0.46-0.13-0.93-0.29-1.39-0.47l0.01-4.08C43.08,51.73,43.54,51.88,44.01,52.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.62,51.55l-0.01,4.08c-0.72-0.28-1.44-0.63-2.15-1.04l0.01-4.08C41.18,50.92,41.9,51.26,42.62,51.55"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "35.56,55.31 35.55,59.39 34.16,58.59 34.18,54.51  "
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.42,55.99 25.41,60.07 19.38,56.59 19.39,52.51  "
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34.18,54.51 34.16,58.59 31.16,60.33 31.17,56.26  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_77_",
    className: "st0",
    d: "M31.17,56.26l-0.01,4.08c-1.78,1.03-3.66,0.94-5.75-0.27l0.01-4.08 C27.51,57.2,29.4,57.29,31.17,56.26z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.17,56.26l-0.01,4.08c-0.35,0.21-0.71,0.37-1.08,0.48l0.01-4.08C30.46,56.63,30.82,56.46,31.17,56.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,56.74l-0.01,4.08c-0.2,0.06-0.41,0.12-0.61,0.15l0.01-4.08C29.69,56.86,29.89,56.81,30.1,56.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.49,56.9l-0.01,4.08c-0.12,0.02-0.25,0.04-0.37,0.05l0.01-4.08C29.24,56.94,29.36,56.92,29.49,56.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.12,56.95l-0.01,4.08c-0.1,0.01-0.21,0.02-0.31,0.02l0.01-4.08C28.91,56.97,29.01,56.96,29.12,56.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.81,56.97l-0.01,4.08c-0.09,0-0.19,0-0.29,0l0.01-4.08C28.62,56.97,28.71,56.97,28.81,56.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52,56.97l-0.01,4.08c-0.09,0-0.19-0.01-0.28-0.02l0.01-4.08C28.33,56.96,28.43,56.97,28.52,56.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24,56.95l-0.01,4.08c-0.1-0.01-0.2-0.02-0.3-0.03l0.01-4.08C28.04,56.94,28.14,56.95,28.24,56.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.94,56.92L27.92,61c-0.11-0.02-0.23-0.04-0.34-0.06l0.01-4.08C27.71,56.88,27.82,56.9,27.94,56.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,56.86l-0.01,4.08c-0.14-0.03-0.28-0.06-0.42-0.1l0.01-4.08C27.31,56.8,27.46,56.83,27.6,56.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.17,56.76l-0.01,4.08c-0.2-0.06-0.41-0.13-0.62-0.21l0.01-4.08C26.76,56.63,26.97,56.7,27.17,56.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.55,56.55l-0.01,4.08c-0.37-0.15-0.75-0.33-1.13-0.55l0.01-4.08C25.8,56.22,26.18,56.4,26.55,56.55"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "47.68,54.9 47.66,58.98 41.93,62.31 41.94,58.23  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_79_",
    className: "st0",
    d: "M41.94,58.23l-0.01,4.08c-1.38-0.38-3.98-1.53-6.38-2.92l0.01-4.08 C37.96,56.7,40.56,57.85,41.94,58.23z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.94,58.23l-0.01,4.08c-0.03-0.01-0.05-0.01-0.08-0.02l0.01-4.08C41.89,58.22,41.92,58.23,41.94,58.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.86,58.21l-0.01,4.08c-0.37-0.11-0.82-0.26-1.32-0.46l0.01-4.08C41.05,57.95,41.5,58.11,41.86,58.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.55,57.75l-0.01,4.08c-1.41-0.55-3.25-1.44-4.99-2.44l0.01-4.08C37.3,56.32,39.14,57.2,40.55,57.75"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.39,52.51l5.64-3.28l-3.01-1.74c-1.99-1.15-2.21-2.09-0.17-3.27l2.99-1.74l16.76,9.68c2.2,1.27,4.7,2.36,6.07,2.74 l-5.73,3.33c-1.38-0.38-3.98-1.53-6.38-2.92l-1.39-0.8l-3,1.74c-1.78,1.03-3.66,0.94-5.75-0.27L19.39,52.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_81_",
    className: "st0",
    d: "M31.24,62.58l0.01-4.08c0,0.56,0.45,1.12,1.32,1.62l-0.01,4.08 C31.69,63.7,31.24,63.14,31.24,62.58z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.58,60.13l-0.01,4.08c-0.87-0.5-1.32-1.06-1.32-1.62l0.01-4.08C31.25,59.06,31.7,59.62,32.58,60.13"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.52,65.29 41.5,69.36 32.57,64.2 32.58,60.13  "
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "74.38,50.45 74.37,54.52 48.28,69.69 48.29,65.61  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_83_",
    className: "st0",
    d: "M48.29,65.61l-0.01,4.08c-1.83,1.06-4.47,1-6.77-0.32l0.01-4.08 C43.81,66.61,46.46,66.67,48.29,65.61z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.29,65.61l-0.01,4.08c-0.31,0.18-0.65,0.33-1,0.45l0.01-4.08C47.64,65.94,47.98,65.79,48.29,65.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.29,66.06l-0.01,4.08c-0.25,0.08-0.5,0.14-0.76,0.19l0.01-4.08C46.78,66.2,47.04,66.14,47.29,66.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.52,66.25l-0.01,4.08c-0.16,0.03-0.33,0.05-0.5,0.07l0.01-4.08C46.19,66.3,46.36,66.28,46.52,66.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.02,66.32l-0.01,4.08c-0.14,0.01-0.28,0.02-0.43,0.03l0.01-4.08C45.74,66.34,45.88,66.33,46.02,66.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,66.35l-0.01,4.08c-0.13,0-0.27,0.01-0.41,0l0.01-4.08C45.33,66.35,45.46,66.35,45.6,66.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.19,66.35l-0.01,4.08c-0.13,0-0.27-0.01-0.41-0.02l0.01-4.08C44.92,66.34,45.06,66.34,45.19,66.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.78,66.33l-0.01,4.08c-0.14-0.01-0.28-0.03-0.42-0.05l0.01-4.08C44.5,66.3,44.64,66.31,44.78,66.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,66.28l-0.01,4.08c-0.16-0.02-0.31-0.05-0.47-0.08l0.01-4.08C44.05,66.23,44.2,66.26,44.36,66.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.89,66.2l-0.01,4.08c-0.18-0.04-0.37-0.08-0.55-0.14l0.01-4.08C43.52,66.11,43.7,66.16,43.89,66.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,66.06l-0.01,4.08c-0.24-0.07-0.49-0.15-0.73-0.25l0.01-4.08C42.85,65.91,43.09,65.99,43.34,66.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.61,65.81l-0.01,4.08c-0.37-0.15-0.73-0.32-1.09-0.53l0.01-4.08C41.87,65.49,42.24,65.67,42.61,65.81"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.46,57l2.39-1.39l6.84,3.95l24.16-14.04l8.53,4.92L48.29,65.61c-1.83,1.06-4.47,1-6.77-0.32l-8.94-5.16 C30.89,59.15,30.78,57.97,32.46,57z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "51.22,70.89 51.21,74.96 46.31,72.13 46.32,68.06  "
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "84.29,56.17 84.28,60.25 58.44,75.26 58.45,71.18  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_85_",
    className: "st0",
    d: "M58.45,71.18l-0.01,4.08c-1.88,1.09-5.24,0.86-7.23-0.29l0.01-4.08 C53.21,72.04,56.57,72.28,58.45,71.18z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.45,71.18l-0.01,4.08c-0.26,0.15-0.56,0.28-0.88,0.38l0.01-4.08C57.89,71.47,58.19,71.34,58.45,71.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.58,71.57l-0.01,4.08c-0.25,0.08-0.52,0.15-0.8,0.2l0.01-4.08C57.05,71.72,57.32,71.65,57.58,71.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,71.77l-0.01,4.08c-0.19,0.03-0.39,0.06-0.58,0.08l0.01-4.08C56.39,71.83,56.58,71.8,56.78,71.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.19,71.85l-0.01,4.08c-0.18,0.02-0.36,0.03-0.54,0.04l0.01-4.08C55.83,71.88,56.01,71.87,56.19,71.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.65,71.88l-0.01,4.08c-0.18,0.01-0.35,0.01-0.53,0l0.01-4.08C55.29,71.89,55.47,71.89,55.65,71.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.11,71.89l-0.01,4.08c-0.18,0-0.36-0.01-0.54-0.03l0.01-4.08C54.75,71.87,54.93,71.88,55.11,71.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,71.86l-0.01,4.08c-0.19-0.02-0.37-0.04-0.56-0.06l0.01-4.08C54.2,71.82,54.39,71.84,54.57,71.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.01,71.79L54,75.87c-0.2-0.03-0.4-0.06-0.59-0.1l0.01-4.08C53.62,71.73,53.82,71.77,54.01,71.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,71.69l-0.01,4.08c-0.22-0.04-0.43-0.1-0.64-0.16l0.01-4.08C52.99,71.59,53.21,71.65,53.42,71.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79,71.53l-0.01,4.08c-0.25-0.07-0.5-0.15-0.73-0.25l0.01-4.08C52.29,71.38,52.53,71.46,52.79,71.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.06,71.29l-0.01,4.08c-0.3-0.12-0.58-0.25-0.83-0.4l0.01-4.08C51.48,71.04,51.76,71.17,52.06,71.29"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,51.1l8.79,5.07L58.45,71.18c-1.88,1.09-5.24,0.86-7.23-0.29l-4.9-2.83L75.5,51.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "27.06,58 27.05,62.07 25.12,63.19 25.13,59.12  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_87_",
    className: "st0",
    d: "M1.77,65.71l0.01-4.08c0,0.64,0.52,1.29,1.58,1.91l-0.01,4.08 C2.3,67.01,1.77,66.36,1.77,65.71z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37,63.54l-0.01,4.08c-1.06-0.61-1.58-1.26-1.58-1.91l0.01-4.08C1.78,62.28,2.31,62.93,3.37,63.54"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "18.94,62.72 18.93,66.79 17.2,67.8 17.22,63.72  "
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "35.7,72.39 35.69,76.47 18.93,66.79 18.94,62.72  "
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34.28,81.39 34.26,85.46 3.36,67.62 3.37,63.54  "
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "54.19,73.66 54.18,77.74 40.78,85.52 40.79,81.45  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_89_",
    className: "st0",
    d: "M40.79,81.45l-0.01,4.08c-2.03,1.18-4.42,1.15-6.52-0.06l0.01-4.08 C36.37,82.6,38.76,82.63,40.79,81.45z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  })), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.79,81.45l-0.01,4.08c-0.41,0.24-0.84,0.43-1.27,0.57l0.01-4.08C39.95,81.87,40.38,81.69,40.79,81.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.52,82.01l-0.01,4.08c-0.26,0.08-0.53,0.15-0.79,0.2l0.01-4.08C38.99,82.16,39.26,82.1,39.52,82.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.73,82.21l-0.01,4.08c-0.16,0.03-0.33,0.05-0.49,0.07l0.01-4.08C38.4,82.27,38.56,82.24,38.73,82.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.23,82.28l-0.01,4.08c-0.13,0.01-0.27,0.02-0.4,0.03l0.01-4.08C37.97,82.3,38.1,82.3,38.23,82.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.83,82.31l-0.01,4.08c-0.12,0-0.25,0-0.37,0l0.01-4.08C37.59,82.31,37.71,82.31,37.83,82.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.46,82.31l-0.01,4.08c-0.12,0-0.24-0.01-0.36-0.02l0.01-4.08C37.22,82.3,37.34,82.31,37.46,82.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,82.29l-0.01,4.08c-0.12-0.01-0.25-0.02-0.37-0.04l0.01-4.08C36.86,82.27,36.98,82.28,37.1,82.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,82.25l-0.01,4.08c-0.13-0.02-0.27-0.04-0.4-0.07l0.01-4.08C36.47,82.21,36.6,82.23,36.73,82.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.33,82.18l-0.01,4.08c-0.16-0.03-0.31-0.07-0.47-0.12l0.01-4.08C36.02,82.11,36.17,82.15,36.33,82.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.86,82.06l-0.01,4.08c-0.21-0.06-0.42-0.13-0.62-0.21l0.01-4.08C35.45,81.93,35.65,82,35.86,82.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.24,81.85l-0.01,4.08c-0.33-0.13-0.65-0.28-0.96-0.47l0.01-4.08C34.59,81.57,34.91,81.72,35.24,81.85"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.89,68.8l1.93-1.12l10.37,5.99l-13.4,7.79c-2.03,1.18-4.42,1.15-6.52-0.06L3.37,63.54c-2.09-1.21-2.1-2.57-0.07-3.75 l13.4-7.79L27.06,58l-1.93,1.12L41.89,68.8z M33.98,73.4l1.73-1l-16.76-9.68l-1.73,1L33.98,73.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "104.41,67.9 104.39,71.98 81.05,85.55 81.06,81.47  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_91_",
    className: "st0",
    d: "M84.66,86.2l0.01-4.08c0,0.6,0.43,1.21,1.3,1.71l-0.01,4.08 C85.09,87.41,84.65,86.81,84.66,86.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    className: "st46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.96,83.83l-0.01,4.08c-0.86-0.5-1.3-1.1-1.3-1.71l0.01-4.08C84.67,82.73,85.1,83.34,85.96,83.83"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "87.96,84.98 87.94,89.06 85.95,87.91 85.96,83.83  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_93_",
    className: "st0",
    d: "M61.13,87.61l-0.01,4.08c-2.75,0.65-6.16,0.74-10.28,0.24c-4.08-0.47-7.19-1.33-9.33-2.51 l0.01-4.08c2.14,1.18,5.26,2.03,9.33,2.51C54.98,88.34,58.39,88.25,61.13,87.61z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_93_",
    style: {
      overflow: "visible"
    }
  })), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.13,87.61l-0.01,4.08c-0.31,0.07-0.63,0.14-0.96,0.2l0.01-4.08C60.51,87.75,60.82,87.68,61.13,87.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.18,87.8l-0.01,4.08c-0.54,0.1-1.1,0.17-1.68,0.23l0.01-4.08C59.08,87.98,59.64,87.9,60.18,87.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,88.04l-0.01,4.08c-0.54,0.05-1.11,0.09-1.69,0.11l0.01-4.08C57.39,88.13,57.96,88.09,58.5,88.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.81,88.15l-0.01,4.08c-0.6,0.02-1.23,0.02-1.88,0.01l0.01-4.08C55.58,88.17,56.21,88.17,56.81,88.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93,88.15l-0.01,4.08c-0.72-0.02-1.47-0.06-2.25-0.12l0.01-4.08C53.47,88.09,54.21,88.14,54.93,88.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.69,88.03l-0.01,4.08c-0.6-0.05-1.21-0.11-1.84-0.19c-0.42-0.05-0.82-0.1-1.22-0.16l0.01-4.08 c0.4,0.06,0.8,0.11,1.22,0.16C51.48,87.92,52.09,87.98,52.69,88.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,87.69l-0.01,4.08c-0.86-0.12-1.67-0.26-2.43-0.42l0.01-4.08C47.96,87.42,48.78,87.56,49.64,87.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,87.27l-0.01,4.08c-0.73-0.15-1.42-0.32-2.07-0.5l0.01-4.08C45.78,86.95,46.47,87.11,47.2,87.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.13,86.76l-0.01,4.08c-0.69-0.2-1.34-0.41-1.93-0.65l0.01-4.08C43.79,86.35,44.44,86.56,45.13,86.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2,86.12l-0.01,4.08c-0.61-0.24-1.17-0.5-1.68-0.78l0.01-4.08C42.03,85.61,42.59,85.87,43.2,86.12"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_95_",
    className: "st0",
    d: "M71.69,95.01l0.01-4.08c0.01-2.43,2.64-5.56,9.35-9.46l-0.01,4.08 C74.33,89.45,71.7,92.58,71.69,95.01z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.06,81.47l-0.01,4.08c-0.32,0.19-0.63,0.37-0.93,0.55l0.01-4.08C80.43,81.84,80.74,81.66,81.06,81.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,82.03l-0.01,4.08c-2.37,1.43-4.17,2.76-5.49,3.98L74.63,86C75.95,84.78,77.76,83.46,80.12,82.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63,86l-0.01,4.08c-0.61,0.57-1.12,1.11-1.54,1.64l0.01-4.08C73.51,87.11,74.02,86.57,74.63,86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1,87.64l-0.01,4.08c-0.29,0.37-0.53,0.73-0.73,1.08l0.01-4.08C72.56,88.36,72.8,88.01,73.1,87.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.37,88.71l-0.01,4.08c-0.16,0.28-0.29,0.56-0.39,0.82l0.01-4.08C72.08,89.27,72.21,88.99,72.37,88.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.98,89.54l-0.01,4.08c-0.09,0.24-0.15,0.47-0.2,0.69l0.01-4.08C71.82,90,71.89,89.77,71.98,89.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.78,90.23l-0.01,4.08c-0.04,0.21-0.07,0.42-0.07,0.62l0.01-4.08C71.71,90.64,71.73,90.44,71.78,90.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,90.85l-0.01,4.08c0,0.03,0,0.06,0,0.09l0.01-4.08C71.7,90.91,71.7,90.88,71.7,90.85"
  })))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.06,81.47c-8.58,4.98-10.49,8.7-8.79,11.33l-8.78,5.1c-1.64-1.36-2.72-3.1-3.19-5.13c-0.52-2.01-0.22-3.72,0.84-5.16 c-2.75,0.65-6.16,0.74-10.28,0.24c-4.08-0.47-7.19-1.33-9.33-2.51l8.53-4.95c2.14,0.83,5.1,1,8.71,0.56 c3.66-0.47,7.93-2.12,12.8-4.95l23.35-13.57l9.5,5.49L81.06,81.47z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.27,92.8 72.26,96.88 63.48,101.98 63.49,97.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_97_",
    className: "st0",
    d: "M60.04,94.98l0.01-4.08c0,0.59,0.08,1.21,0.25,1.86c0.47,2.03,1.55,3.78,3.19,5.13 l-0.01,4.08c-1.64-1.36-2.72-3.1-3.19-5.13C60.12,96.19,60.03,95.57,60.04,94.98z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    className: "st49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.49,97.9l-0.01,4.08c-1.64-1.36-2.72-3.1-3.19-5.13c-0.17-0.65-0.25-1.27-0.25-1.86l0.01-4.08 c0,0.59,0.08,1.21,0.25,1.86C60.77,94.8,61.85,96.55,63.49,97.9"
  })))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "68.34,101 68.33,105.07 64.35,102.77 64.36,98.7  "
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "120.25,76.99 120.23,81.07 78.72,105.19 78.73,101.12  "
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.39,80.09l14.56-8.46l9.3,5.37l-41.52,24.13c-2.99,1.74-7.17,1.74-10.39-0.12l-3.98-2.3l23.6-13.71l-1.99-1.15 c-1.69-0.97-1.74-2.37-0.08-3.34l5.59-3.25L96.39,80.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_99_",
    className: "st0",
    d: "M78.73,101.12l-0.01,4.08c-2.99,1.74-7.17,1.74-10.39-0.12l0.01-4.08 C71.56,102.86,75.74,102.86,78.73,101.12z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.73,101.12l-0.01,4.08c-0.56,0.32-1.16,0.59-1.78,0.79l0.01-4.08C77.57,101.7,78.17,101.44,78.73,101.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.95,101.91l-0.01,4.08c-0.43,0.14-0.87,0.25-1.31,0.33l0.01-4.08C76.08,102.15,76.52,102.04,76.95,101.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,102.24l-0.01,4.08c-0.28,0.05-0.56,0.09-0.84,0.12l0.01-4.08C75.08,102.32,75.36,102.29,75.63,102.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,102.35l-0.01,4.08c-0.23,0.02-0.47,0.04-0.71,0.05l0.01-4.08C74.32,102.39,74.56,102.38,74.79,102.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,102.4l-0.01,4.08c-0.22,0.01-0.43,0.01-0.65,0l0.01-4.08C73.65,102.41,73.87,102.41,74.09,102.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,102.4l-0.01,4.08c-0.21-0.01-0.42-0.02-0.64-0.03l0.01-4.08C73.01,102.39,73.22,102.4,73.43,102.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,102.37l-0.01,4.08c-0.22-0.02-0.43-0.04-0.65-0.07l0.01-4.08C72.37,102.33,72.58,102.35,72.8,102.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,102.3l-0.01,4.08c-0.23-0.03-0.46-0.07-0.69-0.12l0.01-4.08C71.69,102.22,71.92,102.26,72.15,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.47,102.18l-0.01,4.08c-0.26-0.05-0.53-0.12-0.79-0.19l0.01-4.08C70.94,102.06,71.2,102.12,71.47,102.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,101.98l-0.01,4.08c-0.33-0.09-0.66-0.21-0.98-0.33l0.01-4.08C70.02,101.78,70.35,101.89,70.68,101.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7,101.65l-0.01,4.08c-0.47-0.18-0.92-0.4-1.35-0.65l0.01-4.08C68.78,101.25,69.23,101.47,69.7,101.65"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "131.07,83.24 131.06,87.32 90.41,110.94 90.42,106.87  "
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.46,106.84 78.45,110.91 75.02,108.94 75.03,104.86  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_101_",
    className: "st0",
    d: "M90.42,106.87l-0.01,4.08c-1.57,0.91-3.51,1.39-5.8,1.42l0.01-4.08 C86.92,108.25,88.85,107.78,90.42,106.87z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_101_",
    style: {
      overflow: "visible"
    }
  })), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.42,106.87l-0.01,4.08c-0.58,0.33-1.2,0.61-1.87,0.83l0.01-4.08C89.22,107.48,89.85,107.2,90.42,106.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,107.69l-0.01,4.08c-0.47,0.15-0.96,0.27-1.48,0.37l0.01-4.08C87.59,107.97,88.08,107.84,88.55,107.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,108.06l-0.01,4.08c-0.35,0.06-0.7,0.11-1.07,0.15l0.01-4.08C86.37,108.17,86.72,108.12,87.07,108.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,108.21l-0.01,4.08c-0.33,0.03-0.67,0.05-1.01,0.07l0.01-4.08C85.33,108.26,85.67,108.24,86,108.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.99,108.27l-0.01,4.08c-0.12,0-0.24,0.01-0.36,0.01l0.01-4.08C84.75,108.28,84.87,108.28,84.99,108.27"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_103_",
    className: "st0",
    d: "M84.63,108.28l-0.01,4.08c-2.34,0.06-4.38-0.41-6.17-1.44l0.01-4.08 C80.24,107.87,82.28,108.34,84.63,108.28z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.63,108.28l-0.01,4.08c-0.25,0.01-0.51,0.01-0.75,0l0.01-4.08C84.12,108.29,84.37,108.29,84.63,108.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,108.28l-0.01,4.08c-0.27-0.01-0.53-0.02-0.78-0.04l0.01-4.08C83.35,108.26,83.61,108.28,83.87,108.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.09,108.24l-0.01,4.08c-0.25-0.02-0.49-0.05-0.74-0.08l0.01-4.08C82.59,108.19,82.84,108.22,83.09,108.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,108.16l-0.01,4.08c-0.25-0.04-0.49-0.08-0.74-0.13l0.01-4.08C81.86,108.08,82.1,108.12,82.35,108.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.62,108.03l-0.01,4.08c-0.27-0.06-0.54-0.12-0.8-0.2l0.01-4.08C81.08,107.91,81.35,107.97,81.62,108.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,107.84l-0.01,4.08c-0.33-0.09-0.66-0.2-0.97-0.33l0.01-4.08C80.16,107.63,80.49,107.74,80.82,107.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,107.51l-0.01,4.08c-0.48-0.19-0.94-0.41-1.39-0.67l0.01-4.08C78.9,107.09,79.37,107.32,79.85,107.51"
  })))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.63,77.79l9.45,5.46l-40.65,23.63c-1.57,0.91-3.51,1.39-5.8,1.42c-2.34,0.06-4.38-0.41-6.17-1.44l-3.42-1.98 L121.63,77.79z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "153.24,95.98 153.22,100.05 149.37,102.29 149.38,98.22  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_105_",
    className: "st0",
    d: "M129.2,103.91l-0.01,4.08c-3.01,0.51-6.62,0.29-10.95-0.68 c-4.28-0.94-7.65-2.12-10.21-3.54l0.01-4.08c2.55,1.42,5.93,2.59,10.21,3.54C122.58,104.2,126.19,104.41,129.2,103.91z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_105_",
    style: {
      overflow: "visible"
    }
  })), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    className: "st53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.2,103.91l-0.01,4.08c-0.4,0.07-0.81,0.12-1.23,0.16l0.01-4.08C128.39,104.03,128.8,103.98,129.2,103.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.97,104.07l-0.01,4.08c-0.44,0.04-0.89,0.07-1.35,0.09l0.01-4.08C127.08,104.15,127.53,104.12,127.97,104.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62,104.16l-0.01,4.08c-0.46,0.02-0.93,0.02-1.42,0.01l0.01-4.08C125.68,104.18,126.16,104.18,126.62,104.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,104.17l-0.01,4.08c-0.52-0.01-1.05-0.04-1.6-0.09l0.01-4.08C124.14,104.13,124.68,104.15,125.2,104.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.59,104.08l-0.01,4.08c-0.63-0.05-1.28-0.13-1.95-0.22l0.01-4.08C122.31,103.95,122.96,104.03,123.59,104.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.64,103.86l-0.01,4.08c-0.83-0.12-1.69-0.27-2.59-0.45l0.01-4.08C119.95,103.59,120.81,103.74,121.64,103.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,103.41l-0.01,4.08c-0.27-0.05-0.53-0.11-0.81-0.17c-1.21-0.27-2.34-0.55-3.41-0.85l0.01-4.08 c1.07,0.3,2.2,0.59,3.41,0.85C118.52,103.29,118.79,103.35,119.05,103.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,102.38l-0.01,4.08c-1.34-0.38-2.57-0.79-3.7-1.24l0.01-4.08C112.27,101.58,113.5,102,114.84,102.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,101.14l-0.01,4.08c-1.15-0.45-2.18-0.93-3.1-1.45l0.01-4.08C108.97,100.21,110,100.69,111.14,101.14"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_107_",
    className: "st0",
    d: "M141.75,110.32l0.01-4.08c0-0.18,0.01-0.35,0.02-0.54c0.19-2.18,2.72-4.66,7.59-7.49 l-0.01,4.08c-4.87,2.83-7.4,5.31-7.59,7.49C141.76,109.97,141.75,110.14,141.75,110.32z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.38,98.22l-0.01,4.08c-0.27,0.16-0.54,0.31-0.79,0.47l0.01-4.08C148.84,98.53,149.11,98.38,149.38,98.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59,98.69l-0.01,4.08c-1.86,1.13-3.34,2.2-4.44,3.21l0.01-4.08C145.25,100.88,146.73,99.81,148.59,98.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,101.9l-0.01,4.08c-0.48,0.45-0.89,0.88-1.23,1.31l0.01-4.08C143.25,102.79,143.66,102.35,144.15,101.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,103.21l-0.01,4.08c-0.23,0.3-0.43,0.59-0.59,0.87l0.01-4.08C142.49,103.8,142.69,103.51,142.92,103.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33,104.09l-0.01,4.08c-0.13,0.23-0.24,0.46-0.32,0.68l0.01-4.08C142.09,104.54,142.2,104.32,142.33,104.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,104.77l-0.01,4.08c-0.07,0.2-0.13,0.39-0.17,0.58l0.01-4.08C141.87,105.16,141.93,104.97,142,104.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,105.35l-0.01,4.08c-0.02,0.12-0.04,0.24-0.05,0.36c-0.01,0.13-0.02,0.25-0.02,0.37l0.01-4.08 c0-0.12,0.01-0.25,0.02-0.37C141.79,105.59,141.81,105.47,141.84,105.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,106.08l-0.01,4.08c0,0.05,0,0.11,0,0.16l0.01-4.08C141.76,106.19,141.76,106.14,141.76,106.08"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "144.47,111.08 144.46,115.16 136.13,120 136.14,115.92  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_109_",
    className: "st0",
    d: "M128.64,110.04l0.01-4.08c0,1.23,0.48,2.6,1.45,4.1c1.59,2.45,3.58,4.37,6.04,5.85 l-0.01,4.08c-2.46-1.48-4.45-3.4-6.04-5.85C129.13,112.64,128.64,111.27,128.64,110.04z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_109_",
    style: {
      overflow: "visible"
    }
  })), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.14,115.92l-0.01,4.08c-2.46-1.48-4.45-3.4-6.04-5.85c-0.96-1.51-1.45-2.88-1.45-4.1l0.01-4.08 c0,1.23,0.48,2.6,1.45,4.1C131.69,112.52,133.68,114.44,136.14,115.92"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.2,103.91c-3.01,0.51-6.62,0.29-10.95-0.68c-4.28-0.94-7.65-2.12-10.21-3.54l8.33-4.84c2.4,1.09,5.46,1.62,9.33,1.56 c3.87-0.06,8.24-1.47,13.11-4.31l3.86-2.24l10.57,6.1l-3.86,2.24c-4.87,2.83-7.4,5.31-7.59,7.49c-0.19,2.18,0.74,3.95,2.68,5.37 l-8.33,4.84c-2.46-1.48-4.45-3.4-6.04-5.85C128.56,107.65,128.24,105.59,129.2,103.91z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "173.42,107.69 173.41,111.76 165.44,116.39 165.45,112.32  "
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "159.84,119.25 159.83,123.32 156.66,121.5 156.67,117.42  "
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "172.19,116.21 172.18,120.29 166.4,123.65 166.41,119.57  "
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "143.9,120.28 143.89,124.36 137.45,120.64 137.46,116.56  "
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "156.67,117.42 156.66,121.5 151.28,124.62 151.29,120.55  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_111_",
    className: "st0",
    d: "M166.41,119.57l-0.01,4.08c-2.08,1.21-4.32,0.97-6.57-0.32l0.01-4.08 C162.09,120.55,164.33,120.78,166.41,119.57z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.41,119.57l-0.01,4.08c-0.38,0.22-0.77,0.39-1.16,0.52l0.01-4.08C165.64,119.97,166.03,119.79,166.41,119.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.25,120.09l-0.01,4.08c-0.24,0.08-0.48,0.14-0.72,0.18l0.01-4.08C164.77,120.23,165.01,120.17,165.25,120.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,120.27l-0.01,4.08c-0.14,0.03-0.29,0.05-0.43,0.06l0.01-4.08C164.25,120.32,164.39,120.3,164.53,120.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,120.33l-0.01,4.08c-0.12,0.01-0.24,0.02-0.36,0.02l0.01-4.08C163.86,120.35,163.98,120.35,164.1,120.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,120.36l-0.01,4.08c-0.11,0-0.22,0-0.34,0l0.01-4.08C163.52,120.36,163.63,120.36,163.74,120.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,120.36l-0.01,4.08c-0.11,0-0.22-0.01-0.34-0.02l0.01-4.08C163.19,120.35,163.3,120.36,163.41,120.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07,120.34l-0.01,4.08c-0.12-0.01-0.24-0.02-0.36-0.04l0.01-4.08C162.84,120.32,162.96,120.33,163.07,120.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,120.3l-0.01,4.08c-0.13-0.02-0.27-0.04-0.4-0.07l0.01-4.08C162.45,120.26,162.58,120.28,162.72,120.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,120.23l-0.01,4.08c-0.16-0.03-0.33-0.07-0.49-0.12l0.01-4.08C161.99,120.16,162.15,120.2,162.32,120.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,120.11l-0.01,4.08c-0.24-0.07-0.48-0.15-0.72-0.24l0.01-4.08C161.35,119.96,161.59,120.04,161.83,120.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11,119.87l-0.01,4.08c-0.42-0.17-0.85-0.37-1.27-0.62l0.01-4.08C160.26,119.49,160.69,119.7,161.11,119.87"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_113_",
    className: "st0",
    d: "M151.29,120.55l-0.01,4.08c-2.08,1.21-4.99,1.12-7.39-0.26l0.01-4.08 C146.3,121.67,149.21,121.75,151.29,120.55z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.29,120.55l-0.01,4.08c-0.36,0.21-0.75,0.38-1.16,0.51l0.01-4.08C150.54,120.93,150.93,120.76,151.29,120.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.13,121.06l-0.01,4.08c-0.28,0.09-0.57,0.16-0.87,0.22l0.01-4.08C149.56,121.22,149.85,121.15,150.13,121.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,121.28l-0.01,4.08c-0.18,0.03-0.37,0.06-0.55,0.08l0.01-4.08C148.9,121.34,149.08,121.31,149.26,121.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,121.36l-0.01,4.08c-0.16,0.02-0.32,0.03-0.48,0.03l0.01-4.08C148.39,121.38,148.55,121.37,148.71,121.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,121.39l-0.01,4.08c-0.15,0.01-0.3,0.01-0.45,0l0.01-4.08C147.93,121.39,148.08,121.39,148.23,121.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,121.39l-0.01,4.08c-0.15,0-0.3-0.01-0.44-0.02l0.01-4.08C147.49,121.38,147.64,121.39,147.78,121.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.34,121.37l-0.01,4.08c-0.15-0.01-0.31-0.03-0.46-0.05l0.01-4.08C147.03,121.34,147.19,121.35,147.34,121.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88,121.31l-0.01,4.08c-0.17-0.02-0.34-0.05-0.51-0.09l0.01-4.08C146.54,121.26,146.71,121.29,146.88,121.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,121.23l-0.01,4.08c-0.19-0.04-0.39-0.09-0.58-0.14l0.01-4.08C145.98,121.14,146.17,121.19,146.37,121.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,121.08l-0.01,4.08c-0.26-0.07-0.51-0.16-0.77-0.26l0.01-4.08C145.27,120.92,145.53,121.01,145.79,121.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.02,120.82l-0.01,4.08c-0.38-0.15-0.76-0.33-1.12-0.54l0.01-4.08C144.27,120.49,144.64,120.67,145.02,120.82"
  })))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.45,112.32l6.74,3.89l-5.78,3.36c-2.08,1.21-4.32,0.97-6.57-0.32l-3.17-1.83l-5.38,3.13 c-2.08,1.21-4.99,1.12-7.39-0.26l-6.44-3.72l25.58-14.87l10.38,5.99L165.45,112.32z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "109.44,113.08 109.43,117.16 109.07,117.37 109.08,113.29  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_115_",
    className: "st0",
    d: "M113.82,113.5l-0.01,4.08c-2.09-1.21-3.32-1.03-4.38-0.41l0.01-4.08 C110.51,112.47,111.73,112.29,113.82,113.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.82,113.5l-0.01,4.08c-0.41-0.24-0.79-0.42-1.14-0.56l0.01-4.08C113.03,113.08,113.41,113.26,113.82,113.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,112.94l-0.01,4.08c-0.18-0.07-0.35-0.13-0.52-0.18l0.01-4.08C112.33,112.81,112.5,112.87,112.68,112.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16,112.76l-0.01,4.08c-0.11-0.03-0.22-0.06-0.32-0.08l0.01-4.08C111.95,112.7,112.05,112.73,112.16,112.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,112.68l-0.01,4.08c-0.08-0.02-0.17-0.03-0.25-0.04l0.01-4.08C111.67,112.65,111.76,112.66,111.84,112.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59,112.64l-0.01,4.08c-0.07-0.01-0.14-0.02-0.21-0.02l0.01-4.08C111.45,112.62,111.52,112.63,111.59,112.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.38,112.61l-0.01,4.08c-0.07-0.01-0.13-0.01-0.19-0.01l0.01-4.08C111.25,112.61,111.32,112.61,111.38,112.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19,112.6l-0.01,4.08c-0.06,0-0.13,0-0.19,0l0.01-4.08C111.06,112.6,111.12,112.6,111.19,112.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,112.6l-0.01,4.08c-0.07,0-0.13,0.01-0.2,0.01l0.01-4.08C110.87,112.61,110.93,112.61,111,112.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,112.62l-0.01,4.08c-0.08,0.01-0.16,0.02-0.24,0.03l0.01-4.08C110.64,112.64,110.72,112.63,110.8,112.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,112.65l-0.01,4.08c-0.14,0.02-0.27,0.06-0.39,0.1l0.01-4.08C110.3,112.71,110.43,112.68,110.56,112.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.17,112.75l-0.01,4.08c-0.26,0.08-0.5,0.2-0.73,0.33l0.01-4.08C109.67,112.95,109.91,112.83,110.17,112.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_117_",
    className: "st0",
    d: "M108.25,118.33l0.01-4.08c0-0.37,0.33-0.67,0.83-0.96l-0.01,4.08 C108.58,117.66,108.25,117.96,108.25,118.33z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_117_",
    style: {
      overflow: "visible"
    }
  })), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.08,113.29l-0.01,4.08c-0.02,0.01-0.04,0.02-0.06,0.04l0.01-4.08C109.04,113.32,109.06,113.3,109.08,113.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.02,113.33l-0.01,4.08c-0.17,0.1-0.32,0.21-0.44,0.32l0.01-4.08C108.7,113.54,108.85,113.43,109.02,113.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,113.65l-0.01,4.08c-0.06,0.05-0.11,0.1-0.15,0.16l0.01-4.08C108.47,113.75,108.52,113.7,108.58,113.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,113.81l-0.01,4.08c-0.03,0.04-0.06,0.08-0.08,0.12l0.01-4.08C108.37,113.89,108.4,113.85,108.43,113.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.35,113.93l-0.01,4.08c-0.02,0.03-0.04,0.07-0.05,0.11l0.01-4.08C108.31,114,108.33,113.96,108.35,113.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,114.03l-0.01,4.08c-0.01,0.03-0.02,0.07-0.03,0.1l0.01-4.08C108.28,114.1,108.29,114.07,108.3,114.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27,114.14l-0.01,4.08c-0.01,0.03-0.01,0.07-0.01,0.1l0.01-4.08C108.26,114.2,108.26,114.17,108.27,114.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.26,114.24l-0.01,4.08c0,0.01,0,0.01,0,0.02l0.01-4.08C108.26,114.25,108.26,114.24,108.26,114.24"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_119_",
    className: "st0",
    d: "M93.03,116.88l0.01-4.08c-0.01,1.79,1.51,3.62,4.16,5.15l-0.01,4.08 C94.53,120.49,93.02,118.67,93.03,116.88z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_120_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_119_",
    style: {
      overflow: "visible"
    }
  })), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    className: "st60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2,117.95l-0.01,4.08c-2.65-1.53-4.16-3.36-4.16-5.15l0.01-4.08C93.03,114.59,94.54,116.42,97.2,117.95"
  })))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "126.59,120.87 126.58,124.95 113.81,117.57 113.82,113.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_121_",
    className: "st0",
    d: "M128.18,122.44l-0.01,4.08c0-0.41-0.43-0.9-1.59-1.57l0.01-4.08 C127.75,121.54,128.18,122.03,128.18,122.44z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_121_",
    style: {
      overflow: "visible"
    }
  })), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.18,122.44l-0.01,4.08c0-0.41-0.43-0.9-1.59-1.57l0.01-4.08C127.75,121.54,128.18,122.03,128.18,122.44"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_123_",
    className: "st0",
    d: "M143.25,123.98l-0.01,4.08c0,1.42-0.97,2.81-3.07,4.03l0.01-4.08 C142.28,126.79,143.25,125.4,143.25,123.98z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    className: "st62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25,123.98l-0.01,4.08c0,0.03,0,0.05,0,0.08l0.01-4.08C143.25,124.03,143.25,124,143.25,123.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25,124.06l-0.01,4.08c0,0.18-0.02,0.35-0.06,0.52l0.01-4.08C143.23,124.41,143.24,124.23,143.25,124.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,124.58l-0.01,4.08c-0.03,0.17-0.08,0.34-0.15,0.51l0.01-4.08C143.11,124.92,143.16,124.75,143.19,124.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.04,125.09l-0.01,4.08c-0.07,0.17-0.15,0.35-0.24,0.52l0.01-4.08C142.9,125.44,142.98,125.27,143.04,125.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,125.61l-0.01,4.08c-0.11,0.19-0.23,0.38-0.38,0.56l0.01-4.08C142.57,125.99,142.69,125.8,142.8,125.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,126.17l-0.01,4.08c-0.18,0.23-0.39,0.45-0.63,0.67l0.01-4.08C142.03,126.63,142.24,126.4,142.42,126.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,126.85l-0.01,4.08c-0.4,0.37-0.89,0.73-1.46,1.07l0.01-4.08C140.91,127.57,141.39,127.22,141.79,126.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,127.92l-0.01,4.08c-0.05,0.03-0.1,0.06-0.15,0.09l0.01-4.08C140.23,127.98,140.28,127.95,140.33,127.92"
  })))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "118.96,130.52 118.95,134.59 97.19,122.03 97.2,117.95  "
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.18,128.01 140.17,132.09 134.79,135.21 134.8,131.14  "
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.06,118.84c4.85,2.8,5.84,6.43,1.12,9.17l-5.38,3.13c-4.72,2.74-10.98,2.18-15.84-0.62L97.2,117.95 c-4.75-2.74-5.84-6.43-1.12-9.17l5.38-3.13c4.72-2.74,11.09-2.12,15.84,0.62L139.06,118.84z M126.96,123.61l0.36-0.21 c1.07-0.62,1.48-1.26-0.73-2.54l-12.77-7.37c-2.09-1.21-3.32-1.03-4.38-0.41l-0.36,0.21c-1.07,0.62-1.37,1.33,0.73,2.54 l12.77,7.37C124.78,124.47,125.9,124.23,126.96,123.61"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_125_",
    className: "st0",
    d: "M134.8,131.14l-0.01,4.08c-4.72,2.74-10.98,2.18-15.84-0.62l0.01-4.08 C123.82,133.32,130.08,133.88,134.8,131.14z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_125_",
    style: {
      overflow: "visible"
    }
  })), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.8,131.14l-0.01,4.08c-0.78,0.46-1.61,0.82-2.47,1.1l0.01-4.08C133.19,131.96,134.02,131.59,134.8,131.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,132.23l-0.01,4.08c-0.59,0.19-1.19,0.34-1.81,0.45l0.01-4.08C131.14,132.58,131.74,132.43,132.33,132.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.53,132.69l-0.01,4.08c-0.39,0.07-0.78,0.13-1.18,0.16l0.01-4.08C129.74,132.81,130.14,132.76,130.53,132.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,132.85l-0.01,4.08c-0.33,0.03-0.67,0.06-1,0.07l0.01-4.08C128.68,132.91,129.02,132.89,129.35,132.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35,132.92l-0.01,4.08c-0.32,0.01-0.63,0.01-0.95,0l0.01-4.08C127.71,132.93,128.03,132.93,128.35,132.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,132.92l-0.01,4.08c-0.32-0.01-0.63-0.03-0.95-0.05l0.01-4.08C126.76,132.9,127.08,132.92,127.4,132.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,132.87l-0.01,4.08c-0.33-0.03-0.66-0.06-1-0.11l0.01-4.08C125.78,132.81,126.11,132.84,126.44,132.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.45,132.76l-0.01,4.08c-0.37-0.05-0.73-0.12-1.1-0.19l0.01-4.08C124.72,132.64,125.08,132.71,125.45,132.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,132.57l-0.01,4.08c-0.43-0.09-0.86-0.2-1.29-0.32l0.01-4.08C123.49,132.37,123.92,132.48,124.35,132.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.06,132.25l-0.01,4.08c-0.57-0.16-1.13-0.35-1.68-0.57l0.01-4.08C121.93,131.9,122.49,132.09,123.06,132.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.38,131.68l-0.01,4.08c-0.83-0.33-1.64-0.72-2.41-1.16l0.01-4.08C119.74,130.96,120.54,131.35,121.38,131.68"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedTxt);
export default __webpack_public_path__ + "static/media/fixedTxt.e333a34d0e4730ece7f6d0c7d80d266a.svg";
export { ForwardRef as ReactComponent };